var _defs, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _rect, _rect2, _rect3, _rect4, _polygon4, _rect5, _rect6, _polygon5, _rect7, _rect8, _polygon6, _polygon7, _polygon8, _polygon9, _rect9, _rect0, _rect1, _rect10, _polygon0, _rect11, _rect12, _polygon1, _rect13, _rect14, _polygon10, _polygon11, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _polygon12, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _polygon13, _rect58, _polygon14, _polygon15, _polygon16, _rect59, _polygon17, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _polygon18, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _polygon19, _rect135, _path4, _rect136, _polygon20, _polygon21, _rect137, _rect138, _rect139, _polygon22, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _polygon23, _polygon24, _polygon25, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _rect285, _rect286, _rect287, _polygon53, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _polygon54, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _polygon55, _rect331, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _rect332, _polygon62, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _polygon63, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _polygon64, _rect408, _path5, _rect409, _polygon65, _polygon66, _rect410, _rect411, _rect412, _polygon67, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _polygon68, _polygon69, _polygon70, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _rect558, _rect559, _rect560, _polygon98, _rect561, _rect562, _rect563, _rect564, _polygon99, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _polygon100, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _polygon101, _polygon102, _rect604, _rect605, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _rect606, _rect607, _polygon109, _polygon110, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _polygon111, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _polygon112, _polygon113, _rect695, _rect696, _rect697, _rect698, _ellipse, _rect699, _rect700, _polygon114, _polygon115, _polygon116, _rect701, _rect702, _rect703, _rect704, _polygon117, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _polygon118, _polygon119, _polygon120, _polygon121, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _rect854, _rect855, _polygon149, _rect856, _path6, _path7, _rect857, _rect858, _path8, _path9, _path0, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _path1, _path10, _path11, _path12, _polygon161, _polygon162, _rect859, _polygon163, _rect860, _polygon164, _rect861, _rect862, _rect863, _polygon165, _polygon166, _rect864, _polygon167, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewYork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 591.67 391.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(35.88 -47.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.27,318.16c-.27,3.46-.69,6.93-1.27,10.36-.07.49-.17,1-.25,1.47a2.14,2.14,0,0,1-.06.27c-.13.75-.28,1.5-.43,2.24,0,.13,0,.28-.08.41-.12.59-.25,1.19-.39,1.77-.4,1.81-.85,3.62-1.35,5.41a106.82,106.82,0,0,1-4.58,13.17c-1.12,2.65-2.36,5.25-3.7,7.79l-.35.64c-.18.35-.37.69-.56,1s-.27.5-.42.73a87.12,87.12,0,0,1-15.51,20.09c-20.13,19.24-48.39,27-75.64,32.82a872.22,872.22,0,0,1-166.76,18.9c-15.08.25-30.38,0-45.6-1A350.43,350.43,0,0,1,157.49,429a253.85,253.85,0,0,1-29.87-7.51s0,0,0,0c-2.26-.72-4.53-1.49-6.77-2.28h0c-1.88-.67-3.76-1.37-5.62-2.1A183.89,183.89,0,0,1,76.7,396.94,165.82,165.82,0,0,1,41.75,364.2a1.6,1.6,0,0,1-.16-.19c-2.32-2.9-4.56-5.89-6.68-9-1.25-1.77-2.46-3.58-3.64-5.4-.5-.78-1-1.55-1.46-2.33-.94-1.51-1.86-3-2.74-4.57-.75-1.29-1.48-2.59-2.21-3.91-1.23-2.28-2.43-4.58-3.56-6.9-.72-1.49-1.44-3-2.12-4.5A167,167,0,0,1,4.62,271c-1.19-16,0-32.39,5.33-47.52,11.24-31.7,39.33-54.38,55.29-84,6.06-11.26,10.33-23.46,17-34.37,14.82-24.32,40.6-40.47,67.87-48.66,28.46-8.55,64.21-14.56,92-1.69,35.26,16.32,57.21,45.89,88.15,67.85,47.13,33.43,114.73,36.2,151.53,80.75,10.42,12.62,17.44,27.7,23,43.1C513,269.43,518.17,293.85,516.27,318.16Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 394.45,
    y1: 300.94,
    x2: 401.16,
    y2: 208.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5174.18,
    y1: 330.63,
    x2: 5180.89,
    y2: 238.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 5274.89, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 5577.37,
    y1: 670.17,
    x2: 5584.08,
    y2: 577.59,
    gradientTransform: "matrix(-0.99, -0.17, -0.17, 0.99, 5717.29, 474.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 108.02,
    y1: 329.06,
    x2: 173.77,
    y2: 418.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 112.77,
    y1: 354.59,
    x2: 164.43,
    y2: 292.43,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 240.48,
    y1: 338.23,
    x2: 261.72,
    y2: 335.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 430.5,
    y1: 333.88,
    x2: 508.66,
    y2: 350.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 463.12,
    y1: 304.85,
    x2: 473.19,
    y2: 288.75,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 465.63,
    y1: 296.63,
    x2: 470.66,
    y2: 285.72,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 465.11,
    y1: 289.14,
    x2: 473.58,
    y2: 286.29,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 421.62,
    y1: 305.88,
    x2: 467.03,
    y2: 305.88,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 446.52,
    y1: 342.86,
    x2: 452.78,
    y2: 226.57,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 406.34,
    y1: 307.76,
    x2: 532.91,
    y2: 298.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 362.9,
    y1: 254.01,
    x2: 360.88,
    y2: 461.32,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 352.43,
    y1: 300.93,
    x2: 385.97,
    y2: 274.32,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 349.42,
    y1: 297.14,
    x2: 382.96,
    y2: 270.53,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 347.25,
    y1: 294.4,
    x2: 380.79,
    y2: 267.79,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 321.46,
    y1: 147.24,
    x2: 343.94,
    y2: 125.61,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 326.45,
    y1: 176.79,
    x2: 336.74,
    y2: 143.02,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 348.72,
    y1: 275.47,
    x2: 412.45,
    y2: 268.76,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 306.21,
    y1: 373.53,
    x2: 409.53,
    y2: 122.62,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 312.81,
    y1: 274.39,
    x2: 424.17,
    y2: 242.64,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 329.39,
    y1: 156.61,
    x2: 338.61,
    y2: 139.34,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 307.91,
    y1: 341.24,
    x2: 399.82,
    y2: 324.47,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 391.67,
    y1: 270.16,
    x2: 393.01,
    y2: 212.91,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 390.63,
    y1: 425.5,
    x2: 393.98,
    y2: 227.59,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 378.51,
    y1: 267.76,
    x2: 379.52,
    y2: 239.24,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 405.11,
    y1: 268.69,
    x2: 406.12,
    y2: 240.18,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 392.22,
    y1: 222.88,
    x2: 392.33,
    y2: 215.89,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 392.13,
    y1: 217.89,
    x2: 392.4,
    y2: 211.52,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 392.09,
    y1: 215.08,
    x2: 392.43,
    y2: 208.03,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 391.76,
    y1: 224.52,
    x2: 392.93,
    y2: 181.24,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 392.06,
    y1: 226.8,
    x2: 392.31,
    y2: 219.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 377.48,
    y1: 311.47,
    x2: 487.84,
    y2: 298.38,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 464.16,
    y1: 398.34,
    x2: 465.72,
    y2: 332.82,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 465.08,
    y1: 333.29,
    x2: 464.83,
    y2: 343.52,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 465.21,
    y1: 330.54,
    x2: 464.7,
    y2: 336.71,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 447.05,
    y1: 361.03,
    x2: 474.89,
    y2: 364.72,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 464.84,
    y1: 327.95,
    x2: 464.95,
    y2: 340.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 468.14,
    y1: 333.19,
    x2: 467.89,
    y2: 338.81,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 311.98,
    y1: 326.38,
    x2: 307.4,
    y2: 387.21,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 305.83,
    y1: 363.96,
    x2: 313.43,
    y2: 253.94,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 302.9,
    y1: 343.89,
    x2: 334.43,
    y2: 289.55,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 278.53,
    y1: 350.12,
    x2: 339.97,
    y2: 350.12,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 309.73,
    y1: 337.07,
    x2: 308.61,
    y2: 411.76,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 379.37,
    y1: 364.09,
    x2: 481.35,
    y2: 331.44,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 254.3,
    y1: 414.91,
    x2: 283.15,
    y2: 304.89,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 267.29,
    y1: 235.45,
    x2: 263.26,
    y2: 394.67,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 261.42,
    y1: 326.89,
    x2: 269.47,
    y2: 354.17,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 234.85,
    y1: 333.53,
    x2: 284.66,
    y2: 337.55,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 115.83,
    y1: 229.81,
    x2: 92.91,
    y2: 225.44,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 142.08,
    y1: 74.82,
    x2: 143.43,
    y2: 59.89,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 189.74,
    y1: 324.49,
    x2: 227.65,
    y2: 361.05,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 176.5,
    y1: 181.43,
    x2: 158.49,
    y2: 178.19,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 199.88,
    y1: 188.13,
    x2: 211.22,
    y2: 188.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 124.58,
    y1: 188.09,
    x2: 55.14,
    y2: 200.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 147.28,
    y1: 192.28,
    x2: 100.98,
    y2: 181.55,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 137.24,
    y1: 98.18,
    x2: 147.73,
    y2: 98.18,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 137.91,
    y1: 111.55,
    x2: 146.99,
    y2: 111.55,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 138.23,
    y1: 115.22,
    x2: 146.74,
    y2: 115.22,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 140.5,
    y1: 117.87,
    x2: 144.4,
    y2: 117.87,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 129.35,
    y1: 81.83,
    x2: 155.62,
    y2: 81.83,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 99.38,
    y1: 114.12,
    x2: 122.19,
    y2: 87.96,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 151.53,
    y1: 220.08,
    x2: 156.56,
    y2: 187.71,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 106.29,
    y1: 327.76,
    x2: 203.1,
    y2: 327.76,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 206.18,
    y1: 243.67,
    x2: 256.05,
    y2: 238.75,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 235.87,
    y1: 253.48,
    x2: 274.61,
    y2: 278.3,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 216.6,
    y1: 252.01,
    x2: 265.8,
    y2: 258.94,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 149.14,
    y1: 270.06,
    x2: 286,
    y2: 338.49,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 156.89,
    y1: 349.86,
    x2: 242.77,
    y2: 339.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 126.77,
    y1: 251.28,
    x2: 107.99,
    y2: 213.71,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 99.47,
    y1: 143.7,
    x2: 111.86,
    y2: 143.7,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 138.33,
    y1: 228.02,
    x2: 175.43,
    y2: 228.02,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 212.51,
    y1: 301.27,
    x2: 223.91,
    y2: 301.27,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 215.4,
    y1: 307.35,
    x2: 241.23,
    y2: 278.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 214.64,
    y1: 306.67,
    x2: 240.47,
    y2: 277.98,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 214.56,
    y1: 306.59,
    x2: 240.39,
    y2: 277.91,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 214.06,
    y1: 306.15,
    x2: 239.89,
    y2: 277.47,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 105.13,
    y1: 248.77,
    x2: 144.04,
    y2: 227.52,
    xlinkHref: "#linear-gradient-4"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New York") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.27,318.16c-.27,3.46-.69,6.93-1.27,10.36-.07.49-.17,1-.25,1.47a2.14,2.14,0,0,1-.06.27c-.13.75-.28,1.5-.43,2.24,0,.13,0,.28-.08.41-.12.59-.25,1.19-.39,1.77-.4,1.81-.85,3.62-1.35,5.41a106.82,106.82,0,0,1-4.58,13.17c-1.12,2.65-2.36,5.25-3.7,7.79l-.35.64c-.18.35-.37.69-.56,1s-.27.5-.42.73a87.12,87.12,0,0,1-15.51,20.09c-20.13,19.24-48.39,27-75.64,32.82a872.22,872.22,0,0,1-166.76,18.9c-15.08.25-30.38,0-45.6-1A350.43,350.43,0,0,1,157.49,429a253.85,253.85,0,0,1-29.87-7.51s0,0,0,0c-2.26-.72-4.53-1.49-6.77-2.28h0c-1.88-.67-3.76-1.37-5.62-2.1A183.89,183.89,0,0,1,76.7,396.94,165.82,165.82,0,0,1,41.75,364.2a1.6,1.6,0,0,1-.16-.19c-2.32-2.9-4.56-5.89-6.68-9-1.25-1.77-2.46-3.58-3.64-5.4-.5-.78-1-1.55-1.46-2.33-.94-1.51-1.86-3-2.74-4.57-.75-1.29-1.48-2.59-2.21-3.91-1.23-2.28-2.43-4.58-3.56-6.9-.72-1.49-1.44-3-2.12-4.5A167,167,0,0,1,4.62,271c-1.19-16,0-32.39,5.33-47.52,11.24-31.7,39.33-54.38,55.29-84,6.06-11.26,10.33-23.46,17-34.37,14.82-24.32,40.6-40.47,67.87-48.66,28.46-8.55,64.21-14.56,92-1.69,35.26,16.32,57.21,45.89,88.15,67.85,47.13,33.43,114.73,36.2,151.53,80.75,10.42,12.62,17.44,27.7,23,43.1C513,269.43,518.17,293.85,516.27,318.16Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5",
    opacity: 0.32,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M530.93,309.27a188.49,188.49,0,0,1-7.22,46.35c-41.26,2.52-82.76-2.48-124.16-4-42.61-1.6-85.31.48-127.9-1.64-3.79-.19-8.09-.68-10.32-3.74s-1.36-7.59-3-11.08c-.91-1.9-2.54-3.45-3-5.5-.54-2.55.93-5,2.35-7.22Q272.36,299.77,288,277.8c2.59-3.62,5.29-7.33,9.09-9.65s9-2.93,12.58-.28a7.45,7.45,0,0,1,7.06-5.55,8.3,8.3,0,0,0,3.38-.2c1.23-.56,1.8-2,2.47-3.14a12.33,12.33,0,0,1,15.84-4.58,24.94,24.94,0,0,1,20.39-9.25c9.54.47,18,6.39,27.45,7.88a34.16,34.16,0,0,0,14.56-1c2.64-.74,5.25-1.78,8-2a13.38,13.38,0,0,1,7.36,1.62,7.3,7.3,0,0,0,3.18,1.28c1.31,0,2.45-.89,3.49-1.68A39.71,39.71,0,0,1,457.48,245c1.88.54,3.79,1.26,5.73,1.09,2.7-.22,5-2.05,7.16-3.64,11.88-8.64,27.16-12.13,41.67-10.26,1.59.2,3.09.44,4.52.71C526,257.51,531.88,283.29,530.93,309.27Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-35.78,339a188.41,188.41,0,0,0,7.22,46.34c41.26,2.53,82.76-2.48,124.16-4,42.61-1.59,85.31.48,127.9-1.64,3.79-.19,8.09-.68,10.32-3.74s1.36-7.59,3-11.08c.91-1.9,2.54-3.44,3-5.49.54-2.55-.93-5-2.35-7.22q-14.65-22.65-30.29-44.62c-2.59-3.62-5.29-7.33-9.09-9.65s-9-2.93-12.58-.27a7.45,7.45,0,0,0-7.06-5.56c-1.14,0-2.34.27-3.38-.2-1.23-.56-1.8-1.95-2.47-3.13a12.33,12.33,0,0,0-15.84-4.59,25,25,0,0,0-20.39-9.24c-9.54.46-18,6.38-27.45,7.87a33.79,33.79,0,0,1-14.55-1c-2.65-.74-5.26-1.77-8-2A13.56,13.56,0,0,0,79,281.36a7.18,7.18,0,0,1-3.18,1.28c-1.31,0-2.44-.88-3.49-1.68a39.71,39.71,0,0,0-34.65-6.29c-1.88.55-3.79,1.26-5.73,1.1-2.7-.23-5-2-7.16-3.65C12.9,263.48-2.38,260-16.89,261.86c-1.59.2-3.09.44-4.52.72C-30.85,287.19-36.73,313-35.78,339Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-29.34,183.76a188.19,188.19,0,0,0-.67,46.9c40.25,9.42,82,11.46,123.07,16.89,42.28,5.58,84,14.8,126.36,19.86,3.77.45,8.09.69,10.8-2s2.62-7.25,4.83-10.42c1.21-1.71,3.08-3,3.85-4.91,1-2.43-.07-5.13-1.1-7.51q-10.63-24.8-22.37-49.08c-1.94-4-4-8.11-7.34-11s-8.39-4.4-12.36-2.38a7.42,7.42,0,0,0-6-6.66c-1.12-.19-2.35-.13-3.3-.77-1.11-.75-1.44-2.22-1.9-3.5A12.33,12.33,0,0,0,169.66,162a25,25,0,0,0-18.54-12.54c-9.49-1.15-18.83,3.27-28.39,3.15a34,34,0,0,1-14.18-3.42c-2.48-1.17-4.88-2.63-7.55-3.29a13.32,13.32,0,0,0-7.53.36,7.24,7.24,0,0,1-3.35.72c-1.29-.21-2.26-1.28-3.16-2.24a39.68,39.68,0,0,0-33.09-12c-1.95.22-3.95.6-5.84.11-2.63-.67-4.55-2.85-6.44-4.79-10.26-10.51-24.74-16.52-39.36-17.12-1.6-.06-3.12-.08-4.57-.05C-15.78,133.56-25.91,158-29.34,183.76Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient-3)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "115.31 383.14 124.44 383.14 124.44 341.06 115.31 331.48 115.31 383.14",
    fill: "#2c7be5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "556.98 382.1 572.48 382.1 572.48 335.13 556.98 343.84 556.98 382.1",
    fill: "#2c7be5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "583.07 330.44 583.07 382.1 591.67 382.1 591.67 339.22 583.07 330.44",
    fill: "#2c7be5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 542.5,
    y: 337.81,
    width: 14.48,
    height: 44.29,
    fill: "#2c7be5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 547.96,
    y: 332.04,
    width: 9.03,
    height: 6.18,
    fill: "#2c7be5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 528.03,
    y: 328.46,
    width: 14.48,
    height: 53.64,
    fill: "#2c7be5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 530.76,
    y: 320.98,
    width: 9.02,
    height: 7.48,
    fill: "#2c7be5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "532.75 308.95 532.75 320.98 537.78 320.98 537.78 308.95 535.27 303.69 532.75 308.95",
    fill: "#2c7be5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 571.46,
    y: 359.71,
    width: 11.61,
    height: 22.39,
    fill: "#2c7be5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 573.65,
    y: 356.59,
    width: 7.23,
    height: 3.13,
    fill: "#2c7be5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "575.25 353.46 575.25 356.58 579.29 356.58 579.29 353.46 577.27 350.04 575.25 353.46",
    fill: "#2c7be5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 486.6,
    y: 348.17,
    width: 11.61,
    height: 33.93,
    fill: "#2c7be5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 488.79,
    y: 343.44,
    width: 7.24,
    height: 4.73,
    fill: "#2c7be5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "490.39 338.71 490.39 343.44 494.42 343.44 494.42 338.71 492.41 333.52 490.39 338.71",
    fill: "#2c7be5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "522.99 355.51 522.99 382.1 528.03 382.1 528.03 355.51 525.51 326.41 522.99 355.51",
    fill: "#2c7be5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "481.49 382.1 495.97 382.1 495.97 354.59 481.49 348.33 481.49 382.1",
    fill: "#2c7be5"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "520.27 382.1 529.39 382.1 529.39 354.59 520.27 348.33 520.27 382.1",
    fill: "#2c7be5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 458.02,
    y: 336.83,
    width: 14.48,
    height: 45.27,
    fill: "#2c7be5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 460.76,
    y: 330.51,
    width: 9.02,
    height: 6.32,
    fill: "#2c7be5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 442.35,
    y: 354.17,
    width: 14.48,
    height: 27.93,
    fill: "#2c7be5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 445.08,
    y: 350.27,
    width: 9.02,
    height: 3.9,
    fill: "#2c7be5"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "447.07 344 447.07 350.27 452.1 350.27 452.1 344 449.59 337.15 447.07 344",
    fill: "#2c7be5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 498.21,
    y: 359.71,
    width: 11.61,
    height: 22.39,
    fill: "#2c7be5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 500.4,
    y: 356.58,
    width: 7.23,
    height: 3.12,
    fill: "#2c7be5"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "502 353.46 502 356.58 506.04 356.58 506.04 353.46 504.02 350.04 502 353.46",
    fill: "#2c7be5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 508.66,
    y: 336.82,
    width: 11.61,
    height: 45.28,
    fill: "#2c7be5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 510.84,
    y: 323.88,
    width: 7.23,
    height: 12.93,
    fill: "#2c7be5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "512.45 324.18 512.45 330.5 516.49 330.5 516.49 324.18 514.46 317.27 512.45 324.18",
    fill: "#2c7be5"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "474.66 360.69 474.66 382.1 479.69 382.1 479.69 360.69 477.17 337.25 474.66 360.69",
    fill: "#2c7be5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 114.63,
    y: 344.26,
    width: 37.82,
    height: 38.88,
    fill: "#2c7be5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 114.63,
    y: 344.26,
    width: 37.82,
    height: 38.88,
    opacity: 0.58,
    fill: "url(#linear-gradient-4)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 117.94,
    y: 314.88,
    width: 31.26,
    height: 29.39,
    fill: "#2c7be5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 117.94,
    y: 314.88,
    width: 31.26,
    height: 29.39,
    fill: "#2c7be5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 117.94,
    y: 314.88,
    width: 31.26,
    height: 29.39,
    opacity: 0.58,
    fill: "url(#linear-gradient-5)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 121.26,
    y: 311.07,
    width: 24.61,
    height: 3.81,
    fill: "#2c7be5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 117.94,
    y: 314.88,
    width: 3.33,
    height: 4.96,
    fill: "#2c7be5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 145.87,
    y: 314.88,
    width: 3.33,
    height: 4.96,
    fill: "#2c7be5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 121.26,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 119.6,
    y: 319.83,
    width: 0.38,
    height: 63.32,
    fill: "#2c7be5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 117.94,
    y: 319.83,
    width: 0.38,
    height: 63.31,
    fill: "#2c7be5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 116.28,
    y: 344.3,
    width: 0.38,
    height: 38.84,
    fill: "#2c7be5"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 114.61,
    y: 344.3,
    width: 0.38,
    height: 38.84,
    fill: "#2c7be5"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 147.08,
    y: 319.83,
    width: 0.38,
    height: 63.32,
    fill: "#2c7be5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 148.75,
    y: 319.83,
    width: 0.38,
    height: 63.31,
    fill: "#2c7be5"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 150.41,
    y: 344.3,
    width: 0.38,
    height: 38.84,
    fill: "#2c7be5"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 152.07,
    y: 344.3,
    width: 0.38,
    height: 38.84,
    fill: "#2c7be5"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 122.78,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 124.3,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 125.82,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 127.33,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 128.85,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 130.37,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 131.88,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 134.92,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 136.43,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 137.95,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 139.47,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 140.98,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 142.5,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 144.02,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 145.54,
    y: 314.88,
    width: 0.38,
    height: 68.27,
    fill: "#2c7be5"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 124.31,
    y: 308.45,
    width: 18.83,
    height: 2.62,
    fill: "#2c7be5"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "127.29 304.43 124.31 308.45 143.15 308.45 140.17 304.43 127.29 304.43",
    fill: "#2c7be5"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 277.47,
    y: 343.08,
    width: 23.44,
    height: 40.06,
    fill: "#2c7be5"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 339.83,
    width: 19.92,
    height: 3.82,
    fill: "#2c7be5"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 282.03,
    y: 337.93,
    width: 14.32,
    height: 1.91,
    fill: "#2c7be5"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 284.51,
    y: 336.02,
    width: 9.36,
    height: 2.26,
    fill: "#2c7be5"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 229.58,
    y: 293.54,
    width: 19.72,
    height: 89.6,
    fill: "#2c7be5"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 229.58,
    y: 293.54,
    width: 19.72,
    height: 89.6,
    opacity: 0.58,
    fill: "url(#linear-gradient-6)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 231.06,
    y: 286.26,
    width: 16.76,
    height: 7.94,
    fill: "#2c7be5"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 233.42,
    y: 282,
    width: 12.05,
    height: 4.78,
    fill: "#2c7be5"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 277.73,
    width: 7.87,
    height: 4.88,
    fill: "#2c7be5"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "215.65 239.55 219.17 239.55 217.41 220.03 215.65 239.55",
    fill: "#2c7be5"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 206.58,
    y: 244.17,
    width: 21.48,
    height: 5.72,
    fill: "#2c7be5"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.01 249.44 196.01 383.14 238.81 383.14 238.81 249.44 217.43 246.94 196.01 249.44",
    fill: "#2c7be5"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.01 383.14 238.86 383.14 217.43 246.94 196.01 383.14",
    fill: "#2c7be5"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.01 383.14 217.43 246.94 196.01 249.44 196.01 383.14",
    fill: "#2c7be5"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 211.51,
    y: 239.43,
    width: 11.42,
    height: 4.74,
    fill: "#2c7be5"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.35 302.17 196.01 383.14 238.86 383.14 228.51 302.17 206.35 302.17",
    fill: "#2c7be5"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 249.38,
    y: 309.89,
    width: 27.45,
    height: 23.71,
    fill: "#2c7be5"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 245.54,
    y: 333.54,
    width: 35.13,
    height: 49.6,
    fill: "#2c7be5"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 247.01,
    y: 319.67,
    width: 11.58,
    height: 13.88,
    fill: "#2c7be5"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 267.82,
    y: 319.67,
    width: 11.58,
    height: 13.88,
    fill: "#2c7be5"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 258.58,
    y: 333.54,
    width: 9.22,
    height: 49.6,
    fill: "#2c7be5"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 251.79,
    y: 304.57,
    width: 22.64,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 253.77,
    y: 302.33,
    width: 18.67,
    height: 2.24,
    fill: "#2c7be5"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 255.86,
    y: 300.59,
    width: 14.5,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 257.65,
    y: 299.27,
    width: 10.92,
    height: 1.41,
    fill: "#2c7be5"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 286.4,
    width: 5.59,
    height: 3.18,
    fill: "#2c7be5"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.11 286.57 264.11 286.57 263.11 259.82 262.11 286.57",
    fill: "#2c7be5"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 258.88,
    y: 289.58,
    width: 8.46,
    height: 16.13,
    fill: "#2c7be5"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 261.53,
    y: 290.62,
    width: 3.15,
    height: 16.63,
    fill: "#2c7be5"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 250.13,
    y: 307.29,
    width: 25.83,
    height: 2.62,
    fill: "#2c7be5"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 264.93,
    y: 286.4,
    width: 0.97,
    height: 3.18,
    fill: "#2c7be5"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 265.82,
    y: 289.58,
    width: 1.51,
    height: 9.68,
    fill: "#2c7be5"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 286.4,
    width: 0.97,
    height: 3.18,
    fill: "#2c7be5"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 257.65,
    y: 299.29,
    width: 0.97,
    height: 1.3,
    fill: "#2c7be5"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 255.86,
    y: 300.59,
    width: 0.97,
    height: 1.73,
    fill: "#2c7be5"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 253.77,
    y: 302.32,
    width: 0.97,
    height: 2.26,
    fill: "#2c7be5"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 251.79,
    y: 304.58,
    width: 0.97,
    height: 2.69,
    fill: "#2c7be5"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 299.29,
    width: 0.97,
    height: 1.3,
    fill: "#2c7be5"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 269.39,
    y: 300.59,
    width: 0.97,
    height: 1.73,
    fill: "#2c7be5"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 271.47,
    y: 302.32,
    width: 0.97,
    height: 2.26,
    fill: "#2c7be5"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 273.46,
    y: 304.58,
    width: 0.97,
    height: 2.69,
    fill: "#2c7be5"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 258.88,
    y: 289.58,
    width: 0.97,
    height: 9.71,
    fill: "#2c7be5"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 269.67,
    y: 321.27,
    width: 1.73,
    height: 12.25,
    fill: "#2c7be5"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 321.27,
    width: 1.73,
    height: 12.27,
    fill: "#2c7be5"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 276.12,
    y: 321.27,
    width: 1.73,
    height: 12.27,
    fill: "#2c7be5"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 270.97,
    y: 321.27,
    width: 0.43,
    height: 12.25,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 274.2,
    y: 321.27,
    width: 0.43,
    height: 12.27,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 277.37,
    y: 321.27,
    width: 0.48,
    height: 12.27,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 248.71,
    y: 321.26,
    width: 1.73,
    height: 12.25,
    fill: "#2c7be5"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 251.93,
    y: 321.26,
    width: 1.73,
    height: 12.27,
    fill: "#2c7be5"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 255.15,
    y: 321.26,
    width: 1.73,
    height: 12.27,
    fill: "#2c7be5"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 250.01,
    y: 321.26,
    width: 0.43,
    height: 12.25,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 253.23,
    y: 321.26,
    width: 0.43,
    height: 12.27,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 321.26,
    width: 0.48,
    height: 12.27,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 269.67,
    y: 312.18,
    width: 1.73,
    height: 7.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 312.18,
    width: 1.73,
    height: 7.49,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 270.97,
    y: 312.18,
    width: 0.43,
    height: 7.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 274.2,
    y: 312.18,
    width: 0.43,
    height: 7.49,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 251.93,
    y: 312.17,
    width: 1.73,
    height: 7.49,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 255.15,
    y: 312.17,
    width: 1.73,
    height: 7.49,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 253.23,
    y: 312.17,
    width: 0.43,
    height: 7.49,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 312.17,
    width: 0.48,
    height: 7.49,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 247.43,
    y: 335.03,
    width: 2,
    height: 48.11,
    fill: "#2c7be5"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 251.16,
    y: 335.03,
    width: 2,
    height: 48.11,
    fill: "#2c7be5"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 254.88,
    y: 335.03,
    width: 2,
    height: 48.11,
    fill: "#2c7be5"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 248.93,
    y: 335.03,
    width: 0.5,
    height: 48.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 252.66,
    y: 335.03,
    width: 0.5,
    height: 48.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 256.33,
    y: 335.03,
    width: 0.56,
    height: 48.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 269.68,
    y: 335.02,
    width: 2,
    height: 48.12,
    fill: "#2c7be5"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 273.41,
    y: 335.02,
    width: 2,
    height: 48.12,
    fill: "#2c7be5"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 277.14,
    y: 335.02,
    width: 2,
    height: 48.12,
    fill: "#2c7be5"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 271.19,
    y: 335.02,
    width: 0.5,
    height: 48.12,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 274.91,
    y: 335.02,
    width: 0.5,
    height: 48.12,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 278.58,
    y: 335.02,
    width: 0.56,
    height: 48.12,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 267.15,
    y: 319.64,
    width: 0.76,
    height: 63.5,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 259.58,
    y: 312.22,
    width: 1.56,
    height: 70.93,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 262.47,
    y: 312.22,
    width: 1.56,
    height: 70.93,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 265.37,
    y: 312.22,
    width: 1.56,
    height: 70.93,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 260.75,
    y: 312.22,
    width: 0.39,
    height: 70.93,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 263.64,
    y: 312.22,
    width: 0.39,
    height: 70.93,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 266.49,
    y: 312.22,
    width: 0.43,
    height: 70.93,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 251.79,
    y: 308.41,
    width: 1.44,
    height: 1.5,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 255.33,
    y: 308.41,
    width: 1.44,
    height: 1.5,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 258.87,
    y: 308.41,
    width: 1.44,
    height: 1.5,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 262.42,
    y: 308.41,
    width: 1.44,
    height: 1.5,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 265.96,
    y: 308.41,
    width: 1.44,
    height: 1.5,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 269.5,
    y: 308.41,
    width: 1.44,
    height: 1.5,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 273.04,
    y: 308.41,
    width: 1.44,
    height: 1.5,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 308.15,
    y: 336.02,
    width: 23.44,
    height: 47.13,
    fill: "#2c7be5"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 309.91,
    y: 332.19,
    width: 19.92,
    height: 4.44,
    fill: "#2c7be5"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 312.71,
    y: 329.95,
    width: 14.32,
    height: 2.65,
    fill: "#2c7be5"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 315.19,
    y: 327.7,
    width: 9.36,
    height: 2.65,
    fill: "#2c7be5"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "315.19 330 312.71 330 312.71 332.31 309.91 332.31 309.91 336.01 308.15 336.01 308.15 383.14 317.55 383.14 317.55 327.7 315.19 327.7 315.19 330",
    fill: "#2c7be5"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 174.04,
    y: 330.67,
    width: 48.16,
    height: 52.47,
    fill: "#2c7be5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.28,325.07c-7,0-12.65,3.6-12.65,8s5.66,8,12.65,8,12.64-3.59,12.64-8S169.26,325.07,162.28,325.07Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 291.01,
    width: 39.8,
    height: 39.66,
    fill: "#2c7be5"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.25 330.67 218.06 330.67 178.25 324.96 178.25 330.67",
    fill: "#2c7be5"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.18 346.8 222.21 346.8 174.18 341.17 174.18 346.8",
    fill: "#2c7be5"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 182.49,
    y: 285.87,
    width: 31.33,
    height: 5.14,
    fill: "#2c7be5"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 172.03,
    y: 346.8,
    width: 52.25,
    height: 36.35,
    fill: "#2c7be5"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 291.01,
    width: 4.23,
    height: 6.69,
    fill: "#2c7be5"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "172 383.14 224.28 383.14 172.03 376.65 172 383.14",
    fill: "#2c7be5"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 213.82,
    y: 291.01,
    width: 4.23,
    height: 6.69,
    fill: "#2c7be5"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 182.49,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 180.37,
    y: 297.69,
    width: 0.49,
    height: 85.45,
    fill: "#2c7be5"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 297.69,
    width: 0.49,
    height: 85.45,
    fill: "#2c7be5"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 176.14,
    y: 330.72,
    width: 0.49,
    height: 52.42,
    fill: "#2c7be5"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 174.02,
    y: 330.72,
    width: 0.49,
    height: 52.42,
    fill: "#2c7be5"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 215.37,
    y: 297.69,
    width: 0.49,
    height: 85.45,
    fill: "#2c7be5"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 217.49,
    y: 297.69,
    width: 0.49,
    height: 85.45,
    fill: "#2c7be5"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 330.72,
    width: 0.49,
    height: 52.42,
    fill: "#2c7be5"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 221.72,
    y: 330.72,
    width: 0.49,
    height: 52.42,
    fill: "#2c7be5"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 184.42,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 186.35,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 188.28,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 190.21,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 192.15,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 194.08,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 196.01,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 197.94,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 199.87,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 201.8,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 203.74,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 205.67,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 207.6,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 209.53,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 211.46,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 213.39,
    y: 291.01,
    width: 0.49,
    height: 92.13,
    fill: "#2c7be5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.33,378h-4.15V338.35h-4.24v-5.14H160.33c-8.49,9.41-9.86,22-9.86,35.83,0,25.8,14.15,47.23,37.93,51.79V394.14h-2.07Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "289.19 383.14 297.01 383.14 297.01 291.09 289.19 298.2 289.19 383.14",
    fill: "#2c7be5"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "297.01 383.14 312.64 383.14 312.64 298.2 297.01 291.09 297.01 383.14",
    fill: "#2c7be5"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "297.01 383.14 297.01 291.09 289.19 383.14 297.01 383.14",
    fill: "#2c7be5"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "312.64 383.14 312.64 298.2 297.01 291.09 312.64 383.14",
    fill: "#2c7be5",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 153.31,
    y: 285.88,
    width: 21.69,
    height: 13.14,
    fill: "#2c7be5"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 154.65,
    y: 281.75,
    width: 19,
    height: 4.4,
    fill: "#2c7be5"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 155.88,
    y: 277.81,
    width: 16.56,
    height: 3.94,
    fill: "#2c7be5"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 157.09,
    y: 273.86,
    width: 14.13,
    height: 3.94,
    fill: "#2c7be5"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 158.37,
    y: 269.92,
    width: 11.56,
    height: 3.94,
    fill: "#2c7be5"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 159.94,
    y: 265.98,
    width: 8.42,
    height: 3.94,
    fill: "#2c7be5"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 153.31,
    y: 285.88,
    width: 11.09,
    height: 13.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 154.65,
    y: 281.75,
    width: 9.74,
    height: 4.13,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 155.88,
    y: 277.81,
    width: 8.52,
    height: 3.94,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 157.09,
    y: 273.86,
    width: 7.3,
    height: 3.94,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 158.37,
    y: 269.92,
    width: 6.02,
    height: 3.94,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 159.94,
    y: 265.98,
    width: 3.7,
    height: 3.94,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 161.22,
    y: 266.19,
    width: 5.87,
    height: 11.54,
    rx: 2.38,
    fill: "#2c7be5"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 161.3,
    y: 262.04,
    width: 5.71,
    height: 3.94,
    fill: "#2c7be5"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 162.58,
    y: 258.1,
    width: 3.14,
    height: 3.94,
    fill: "#2c7be5"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 159.41,
    y: 270.45,
    width: 9.48,
    height: 18.65,
    rx: 3.84,
    fill: "#2c7be5"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 159.41,
    y: 270.91,
    width: 9.48,
    height: 18.65,
    rx: 3.84,
    fill: "#2c7be5"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 158.17,
    y: 274.23,
    width: 11.97,
    height: 23.55,
    rx: 4.85,
    fill: "#2c7be5"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 158.17,
    y: 274.64,
    width: 11.97,
    height: 23.55,
    rx: 4.85,
    fill: "#2c7be5"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 157.03,
    y: 278.16,
    width: 14.24,
    height: 28.01,
    rx: 5.77,
    fill: "#2c7be5"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 157.03,
    y: 278.6,
    width: 14.24,
    height: 28.01,
    rx: 5.77,
    fill: "#2c7be5"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 155.94,
    y: 281.75,
    width: 16.42,
    height: 32.3,
    rx: 6.66,
    fill: "#2c7be5"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 155.94,
    y: 282.17,
    width: 16.42,
    height: 32.3,
    rx: 6.66,
    fill: "#2c7be5"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 159.24,
    y: 284.71,
    width: 9.83,
    height: 24.57,
    rx: 3.99,
    fill: "#2c7be5"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 162.27,
    y: 287.92,
    width: 3.61,
    height: 15.41,
    rx: 1.46,
    fill: "#2c7be5"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 144.92,
    y: 357.52,
    width: 38.44,
    height: 25.62,
    fill: "#2c7be5"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 148.1,
    y: 352.6,
    width: 32.11,
    height: 5.49,
    fill: "#2c7be5"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 348.23,
    width: 29.33,
    height: 5.63,
    fill: "#2c7be5"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 152.17,
    y: 299.01,
    width: 23.98,
    height: 48.42,
    fill: "#2c7be5"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 149.92,
    y: 299.01,
    width: 28.47,
    height: 1.22,
    fill: "#2c7be5"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 153.31,
    y: 300.65,
    width: 4.5,
    height: 45.98,
    fill: "#2c7be5"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 300.65,
    width: 4.5,
    height: 45.98,
    fill: "#2c7be5"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 159.54,
    y: 300.72,
    width: 2.39,
    height: 45.98,
    fill: "#2c7be5"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 161.39,
    y: 300.72,
    width: 0.53,
    height: 45.98,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 150.16,
    y: 349.18,
    width: 27.64,
    height: 1.38,
    fill: "#2c7be5"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 150.16,
    y: 349.18,
    width: 27.64,
    height: 0.31,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 150.16,
    y: 351.22,
    width: 27.64,
    height: 1.38,
    fill: "#2c7be5"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 150.16,
    y: 351.22,
    width: 27.64,
    height: 0.31,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 148.94,
    y: 353.06,
    width: 30.34,
    height: 1.38,
    fill: "#2c7be5"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 148.94,
    y: 353.06,
    width: 30.34,
    height: 0.31,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 148.94,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 148.94,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 152.07,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 152.07,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 155.21,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 155.21,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 158.34,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 158.34,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 161.48,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 161.48,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 164.61,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 164.61,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 167.74,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 167.74,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 170.88,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 170.88,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 174.01,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 174.01,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 177.15,
    y: 354.86,
    width: 2.1,
    height: 2.66,
    fill: "#2c7be5"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 177.15,
    y: 354.86,
    width: 0.47,
    height: 2.66,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 145.74,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 145.74,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 148.88,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 148.88,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 152.01,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 152.01,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 155.15,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 155.15,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 158.28,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 158.28,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 161.41,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 161.41,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 164.55,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 164.55,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 167.68,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 167.68,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 173.95,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 173.95,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 177.15,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 177.15,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 180.28,
    y: 360.28,
    width: 2.1,
    height: 1.74,
    fill: "#2c7be5"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 180.28,
    y: 360.28,
    width: 0.47,
    height: 1.74,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 145.79,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 145.79,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 148.92,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 148.92,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 152.06,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 152.06,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 155.19,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 155.19,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 158.32,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 158.32,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 161.46,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 161.46,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 164.59,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 164.59,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 167.73,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 167.73,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 170.86,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 170.86,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 177.19,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 177.19,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 180.33,
    y: 363.29,
    width: 2.1,
    height: 16.81,
    fill: "#2c7be5"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 180.33,
    y: 363.29,
    width: 0.47,
    height: 16.81,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 163.11,
    y: 300.72,
    width: 2.09,
    height: 45.98,
    fill: "#2c7be5"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 164.73,
    y: 300.72,
    width: 0.47,
    height: 45.98,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 166.51,
    y: 300.72,
    width: 2.09,
    height: 45.98,
    fill: "#2c7be5"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 168.13,
    y: 300.72,
    width: 0.47,
    height: 45.98,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 147.78,
    y: 346.69,
    width: 32.76,
    height: 1.83,
    fill: "#2c7be5"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 160.18,
    y: 296.28,
    width: 1.1,
    height: 2.34,
    fill: "#2c7be5"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 160.18,
    y: 293.29,
    width: 1.1,
    height: 2.34,
    fill: "#2c7be5"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 160.18,
    y: 290.3,
    width: 1.1,
    height: 2.33,
    fill: "#2c7be5"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 296.28,
    width: 1.1,
    height: 2.34,
    fill: "#2c7be5"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 293.29,
    width: 1.1,
    height: 2.34,
    fill: "#2c7be5"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 290.3,
    width: 1.1,
    height: 2.33,
    fill: "#2c7be5"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.16 301.66 152.16 301.67 152.16 346.63 153.3 346.63 153.3 301.67 176.14 301.67 176.14 300.23 152.16 300.23 152.16 301.66",
    fill: "#2c7be5",
    opacity: 0.2
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.31 281.38 165 281.38 164.15 280.06 163.31 281.38",
    fill: "#2c7be5"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "161.11 281.72 162.74 281.43 161.39 280.31 161.11 281.72",
    fill: "#2c7be5"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "159.43 282.36 160.61 281.85 159.12 281.19 159.43 282.36",
    fill: "#2c7be5"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.3 282.97 159.08 282.53 157.91 282.14 158.3 282.97",
    fill: "#2c7be5"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "165.56 281.43 167.19 281.72 166.91 280.31 165.56 281.43",
    fill: "#2c7be5"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.87 282.36 169.18 281.19 167.69 281.85 168.87 282.36",
    fill: "#2c7be5"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "170 282.97 170.39 282.14 169.22 282.53 170 282.97",
    fill: "#2c7be5"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.41 277.87 164.9 277.87 164.15 276.71 163.41 277.87",
    fill: "#2c7be5"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "161.47 278.17 162.91 277.91 161.72 276.93 161.47 278.17",
    fill: "#2c7be5"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "159.99 278.73 161.03 278.29 159.72 277.7 159.99 278.73",
    fill: "#2c7be5"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "159 279.27 159.68 278.88 158.65 278.54 159 279.27",
    fill: "#2c7be5"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "165.4 277.91 166.83 278.17 166.58 276.93 165.4 277.91",
    fill: "#2c7be5"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.31 278.73 168.58 277.7 167.27 278.29 168.31 278.73",
    fill: "#2c7be5"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "169.3 279.27 169.65 278.54 168.62 278.88 169.3 279.27",
    fill: "#2c7be5"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.65 273.83 164.81 273.83 164.23 272.93 163.65 273.83",
    fill: "#2c7be5"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.13 274.07 163.25 273.87 162.33 273.1 162.13 274.07",
    fill: "#2c7be5"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.98 274.51 161.79 274.16 160.77 273.7 160.98 274.51",
    fill: "#2c7be5"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.21 274.93 160.74 274.63 159.94 274.36 160.21 274.93",
    fill: "#2c7be5"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "165.2 273.87 166.32 274.07 166.12 273.1 165.2 273.87",
    fill: "#2c7be5"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.47 274.51 167.68 273.7 166.66 274.16 167.47 274.51",
    fill: "#2c7be5"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.24 274.93 168.51 274.36 167.71 274.63 168.24 274.93",
    fill: "#2c7be5"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.74 270.18 164.54 270.18 164.14 269.63 163.74 270.18",
    fill: "#2c7be5"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.69 270.32 163.46 270.2 162.82 269.73 162.69 270.32",
    fill: "#2c7be5"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "161.89 270.59 162.45 270.38 161.74 270.1 161.89 270.59",
    fill: "#2c7be5"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.81 270.2 165.58 270.32 165.45 269.73 164.81 270.2",
    fill: "#2c7be5"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "166.38 270.59 166.53 270.1 165.82 270.38 166.38 270.59",
    fill: "#2c7be5"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 161.3,
    y: 262.04,
    width: 2.33,
    height: 3.94,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 162.58,
    y: 258.1,
    width: 1.04,
    height: 3.94,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 357.52,
    width: 39.2,
    height: 0.56,
    fill: "#2c7be5"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.14 258.1 165.14 258.1 164.14 242.49 163.14 258.1",
    fill: "#2c7be5"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 335.28,
    y: 347.32,
    width: 40.13,
    height: 35.82,
    fill: "#2c7be5"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 338.79,
    y: 320.25,
    width: 33.16,
    height: 27.07,
    fill: "#2c7be5"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "338.79 347.32 371.95 347.32 338.79 343.42 338.79 347.32",
    fill: "#2c7be5",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 342.32,
    y: 316.73,
    width: 26.11,
    height: 3.51,
    fill: "#2c7be5"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 338.79,
    y: 320.25,
    width: 3.53,
    height: 4.57,
    fill: "#2c7be5"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "335.45 383.14 375.41 383.14 335.48 378.74 335.45 383.14",
    fill: "#2c7be5",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 368.42,
    y: 320.25,
    width: 3.53,
    height: 4.57,
    fill: "#2c7be5"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 342.32,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 340.55,
    y: 324.8,
    width: 0.4,
    height: 58.34,
    fill: "#2c7be5"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 338.79,
    y: 324.81,
    width: 0.4,
    height: 58.33,
    fill: "#2c7be5"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 337.03,
    y: 347.36,
    width: 0.4,
    height: 35.79,
    fill: "#2c7be5"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 347.36,
    width: 0.4,
    height: 35.79,
    fill: "#2c7be5"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 369.71,
    y: 324.8,
    width: 0.4,
    height: 58.34,
    fill: "#2c7be5"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 371.48,
    y: 324.81,
    width: 0.4,
    height: 58.33,
    fill: "#2c7be5"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 373.24,
    y: 347.36,
    width: 0.4,
    height: 35.79,
    fill: "#2c7be5"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 347.36,
    width: 0.4,
    height: 35.79,
    fill: "#2c7be5"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 343.93,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 345.54,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 347.15,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 348.76,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 350.37,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 351.97,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 353.58,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 355.19,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 356.8,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 358.41,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 360.02,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 361.63,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 363.24,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 364.85,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 366.46,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 368.07,
    y: 320.25,
    width: 0.4,
    height: 62.9,
    fill: "#2c7be5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.07,394.66V367.59h-3.52v-3.51H317.87c-7.07,6.42-8.21,15-8.21,24.46,0,17.61,10.06,32.24,29.87,35.36V394.66Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 345.55,
    y: 314.32,
    width: 19.98,
    height: 2.41,
    fill: "#2c7be5"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.71 310.62 345.55 314.32 365.53 314.32 362.37 310.62 348.71 310.62",
    fill: "#2c7be5"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 508.05,
    y: 346.23,
    width: 24.87,
    height: 36.91,
    fill: "#2c7be5"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 509.92,
    y: 343.24,
    width: 21.13,
    height: 3.52,
    fill: "#2c7be5"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 512.89,
    y: 341.48,
    width: 15.19,
    height: 1.76,
    fill: "#2c7be5"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 515.52,
    y: 339.72,
    width: 9.93,
    height: 2.08,
    fill: "#2c7be5"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 457.23,
    y: 300.58,
    width: 20.92,
    height: 82.56,
    fill: "#2c7be5"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 457.23,
    y: 300.58,
    width: 20.92,
    height: 82.56,
    opacity: 0.58,
    fill: "url(#linear-gradient-7)"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 458.81,
    y: 293.88,
    width: 17.78,
    height: 7.31,
    fill: "#2c7be5"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 458.81,
    y: 293.88,
    width: 17.78,
    height: 7.31,
    opacity: 0.58,
    fill: "url(#linear-gradient-8)"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 461.3,
    y: 289.95,
    width: 12.78,
    height: 4.4,
    fill: "#2c7be5"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 461.3,
    y: 289.95,
    width: 12.78,
    height: 4.4,
    opacity: 0.58,
    fill: "url(#linear-gradient-9)"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 463.52,
    y: 286.02,
    width: 8.35,
    height: 4.5,
    fill: "#2c7be5"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 463.52,
    y: 286.02,
    width: 8.35,
    height: 4.5,
    opacity: 0.58,
    fill: "url(#linear-gradient-10)"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    points: "442.46 221.81 446.19 221.81 444.33 203.83 442.46 221.81",
    fill: "#2c7be5"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 432.84,
    y: 226.06,
    width: 22.78,
    height: 5.27,
    fill: "#2c7be5"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.62 230.92 421.62 383.14 467.03 383.14 467.03 230.92 444.35 228.61 421.62 230.92",
    fill: "#2c7be5"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.62 230.92 421.62 383.14 467.03 383.14 467.03 230.92 444.35 228.61 421.62 230.92",
    opacity: 0.58,
    fill: "url(#linear-gradient-11)"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.62 383.14 467.08 383.14 444.35 228.61 421.62 383.14",
    fill: "#2c7be5"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.62 383.14 467.08 383.14 444.35 228.61 421.62 383.14",
    opacity: 0.58,
    fill: "url(#linear-gradient-12)"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.62 383.14 444.35 228.61 421.62 230.92 421.62 383.14",
    fill: "#2c7be5"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.62 383.14 444.35 228.61 421.62 230.92 421.62 383.14",
    fill: "url(#linear-gradient-13)"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 438.06,
    y: 221.7,
    width: 12.12,
    height: 4.37,
    fill: "#2c7be5"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.59 308.53 421.62 383.14 467.08 383.14 456.1 308.53 432.59 308.53",
    fill: "#2c7be5"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 478.24,
    y: 286.62,
    width: 29.13,
    height: 21.85,
    fill: "#2c7be5"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 474.17,
    y: 308.41,
    width: 37.27,
    height: 74.73,
    fill: "#2c7be5"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 475.73,
    y: 295.63,
    width: 12.28,
    height: 12.79,
    fill: "#2c7be5"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 497.81,
    y: 295.63,
    width: 12.29,
    height: 12.79,
    fill: "#2c7be5"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 308.41,
    width: 9.78,
    height: 74.73,
    fill: "#2c7be5"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 480.8,
    y: 281.72,
    width: 24.02,
    height: 2.51,
    fill: "#2c7be5"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 482.9,
    y: 279.65,
    width: 19.8,
    height: 2.07,
    fill: "#2c7be5"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 485.12,
    y: 278.05,
    width: 15.38,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 487.01,
    y: 276.84,
    width: 11.59,
    height: 1.3,
    fill: "#2c7be5"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 489.84,
    y: 264.97,
    width: 5.94,
    height: 2.93,
    fill: "#2c7be5"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    points: "491.75 265.13 493.87 265.13 492.81 240.48 491.75 265.13",
    fill: "#2c7be5"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 488.32,
    y: 267.9,
    width: 8.97,
    height: 14.86,
    fill: "#2c7be5"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 491.14,
    y: 268.86,
    width: 3.34,
    height: 15.32,
    fill: "#2c7be5"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 479.04,
    y: 284.22,
    width: 27.41,
    height: 2.41,
    fill: "#2c7be5"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 494.74,
    y: 264.97,
    width: 1.03,
    height: 2.93,
    fill: "#2c7be5"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 495.69,
    y: 267.9,
    width: 1.61,
    height: 8.92,
    fill: "#2c7be5"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 489.84,
    y: 264.97,
    width: 1.03,
    height: 2.93,
    fill: "#2c7be5"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 487.01,
    y: 276.85,
    width: 1.03,
    height: 1.19,
    fill: "#2c7be5"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 485.12,
    y: 278.05,
    width: 1.03,
    height: 1.59,
    fill: "#2c7be5"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 482.9,
    y: 279.64,
    width: 1.03,
    height: 2.08,
    fill: "#2c7be5"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 480.8,
    y: 281.72,
    width: 1.03,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 497.57,
    y: 276.85,
    width: 1.03,
    height: 1.19,
    fill: "#2c7be5"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 499.47,
    y: 278.05,
    width: 1.03,
    height: 1.59,
    fill: "#2c7be5"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 501.68,
    y: 279.64,
    width: 1.03,
    height: 2.08,
    fill: "#2c7be5"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 503.79,
    y: 281.72,
    width: 1.03,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 488.32,
    y: 267.9,
    width: 1.03,
    height: 8.94,
    fill: "#2c7be5"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 499.77,
    y: 297.11,
    width: 1.84,
    height: 11.29,
    fill: "#2c7be5"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 503.19,
    y: 297.11,
    width: 1.84,
    height: 11.31,
    fill: "#2c7be5"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 506.61,
    y: 297.11,
    width: 1.84,
    height: 11.31,
    fill: "#2c7be5"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 501.15,
    y: 297.11,
    width: 0.46,
    height: 11.29,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 504.57,
    y: 297.11,
    width: 0.46,
    height: 11.31,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 507.94,
    y: 297.11,
    width: 0.51,
    height: 11.31,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 477.53,
    y: 297.1,
    width: 1.84,
    height: 11.29,
    fill: "#2c7be5"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 480.95,
    y: 297.1,
    width: 1.84,
    height: 11.31,
    fill: "#2c7be5"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 484.37,
    y: 297.1,
    width: 1.84,
    height: 11.31,
    fill: "#2c7be5"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 478.91,
    y: 297.1,
    width: 0.46,
    height: 11.29,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 482.33,
    y: 297.1,
    width: 0.46,
    height: 11.31,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 485.69,
    y: 297.1,
    width: 0.51,
    height: 11.31,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 499.77,
    y: 288.73,
    width: 1.84,
    height: 6.89,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 503.19,
    y: 288.73,
    width: 1.84,
    height: 6.9,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 501.15,
    y: 288.73,
    width: 0.46,
    height: 6.89,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 504.57,
    y: 288.73,
    width: 0.46,
    height: 6.9,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 480.95,
    y: 288.72,
    width: 1.84,
    height: 6.9,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 484.37,
    y: 288.72,
    width: 1.84,
    height: 6.9,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 482.33,
    y: 288.72,
    width: 0.46,
    height: 6.9,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 485.69,
    y: 288.72,
    width: 0.51,
    height: 6.9,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 476.17,
    y: 309.78,
    width: 2.13,
    height: 73.36,
    fill: "#2c7be5"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 480.13,
    y: 309.78,
    width: 2.13,
    height: 73.36,
    fill: "#2c7be5"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 484.08,
    y: 309.78,
    width: 2.13,
    height: 73.36,
    fill: "#2c7be5"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 477.77,
    y: 309.78,
    width: 0.53,
    height: 73.36,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 481.72,
    y: 309.78,
    width: 0.53,
    height: 73.36,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 485.61,
    y: 309.78,
    width: 0.59,
    height: 73.36,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 499.78,
    y: 309.77,
    width: 2.13,
    height: 73.37,
    fill: "#2c7be5"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 503.74,
    y: 309.77,
    width: 2.13,
    height: 73.37,
    fill: "#2c7be5"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 507.69,
    y: 309.77,
    width: 2.13,
    height: 73.37,
    fill: "#2c7be5"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 501.38,
    y: 309.77,
    width: 0.53,
    height: 73.37,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 505.33,
    y: 309.77,
    width: 0.53,
    height: 73.37,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 509.23,
    y: 309.77,
    width: 0.59,
    height: 73.37,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 497.1,
    y: 295.6,
    width: 0.8,
    height: 87.54,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 489.06,
    y: 288.76,
    width: 1.65,
    height: 94.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 492.13,
    y: 288.76,
    width: 1.65,
    height: 94.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 495.21,
    y: 288.76,
    width: 1.65,
    height: 94.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 490.3,
    y: 288.76,
    width: 0.41,
    height: 94.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 493.37,
    y: 288.76,
    width: 0.41,
    height: 94.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 496.4,
    y: 288.76,
    width: 0.46,
    height: 94.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 480.8,
    y: 285.25,
    width: 1.53,
    height: 1.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 484.56,
    y: 285.25,
    width: 1.53,
    height: 1.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 488.31,
    y: 285.25,
    width: 1.53,
    height: 1.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 492.07,
    y: 285.25,
    width: 1.53,
    height: 1.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 495.83,
    y: 285.25,
    width: 1.53,
    height: 1.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 499.59,
    y: 285.25,
    width: 1.53,
    height: 1.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 503.35,
    y: 285.25,
    width: 1.53,
    height: 1.38,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 540.59,
    y: 339.72,
    width: 24.87,
    height: 43.42,
    fill: "#2c7be5"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 542.46,
    y: 336.2,
    width: 21.13,
    height: 4.09,
    fill: "#2c7be5"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 545.43,
    y: 334.13,
    width: 15.19,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 548.06,
    y: 332.06,
    width: 9.93,
    height: 2.44,
    fill: "#2c7be5"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    points: "548.06 334.18 545.43 334.18 545.43 336.3 542.46 336.3 542.46 339.72 540.59 339.72 540.59 383.14 550.56 383.14 550.56 332.06 548.06 332.06 548.06 334.18",
    fill: "#2c7be5"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 398.31,
    y: 334.8,
    width: 51.1,
    height: 48.35,
    fill: "#2c7be5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M388,333.36c-7.41,0-13.42,3.31-13.42,7.39s6,7.39,13.42,7.39,13.41-3.31,13.41-7.39S395.43,333.36,388,333.36Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 402.78,
    y: 298.26,
    width: 42.23,
    height: 36.54,
    fill: "#2c7be5"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.78 334.8 445.01 334.8 402.78 329.53 402.78 334.8",
    fill: "#2c7be5"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.45 349.65 449.41 349.65 398.45 344.47 398.45 349.65",
    fill: "#2c7be5"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 407.27,
    y: 293.52,
    width: 33.24,
    height: 4.74,
    fill: "#2c7be5"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 396.18,
    y: 349.65,
    width: 55.44,
    height: 33.49,
    fill: "#2c7be5"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 402.78,
    y: 298.26,
    width: 4.49,
    height: 6.16,
    fill: "#2c7be5"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    points: "396.14 383.14 451.61 383.14 396.18 377.16 396.14 383.14",
    fill: "#2c7be5"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 440.52,
    y: 298.26,
    width: 4.49,
    height: 6.16,
    fill: "#2c7be5"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 407.27,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 405.03,
    y: 304.41,
    width: 0.52,
    height: 78.73,
    fill: "#2c7be5"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 402.78,
    y: 304.41,
    width: 0.52,
    height: 78.73,
    fill: "#2c7be5"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 400.53,
    y: 334.84,
    width: 0.51,
    height: 48.3,
    fill: "#2c7be5"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 398.29,
    y: 334.84,
    width: 0.52,
    height: 48.3,
    fill: "#2c7be5"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 442.16,
    y: 304.41,
    width: 0.52,
    height: 78.73,
    fill: "#2c7be5"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 444.4,
    y: 304.41,
    width: 0.52,
    height: 78.73,
    fill: "#2c7be5"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 446.65,
    y: 334.84,
    width: 0.52,
    height: 48.3,
    fill: "#2c7be5"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 448.9,
    y: 334.84,
    width: 0.51,
    height: 48.3,
    fill: "#2c7be5"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 409.32,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 411.37,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 413.42,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 415.47,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 417.52,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 419.57,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 421.62,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 423.67,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 425.72,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 427.77,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 429.82,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 431.87,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 433.92,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 435.96,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 438.01,
    y: 298.26,
    width: 0.52,
    height: 84.89,
    fill: "#2c7be5"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 440.06,
    y: 298.26,
    width: 0.51,
    height: 84.89,
    fill: "#2c7be5"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "520.48 383.14 528.78 383.14 528.78 298.33 520.48 304.88 520.48 383.14",
    fill: "#2c7be5"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    points: "528.78 383.14 545.36 383.14 545.36 304.88 528.78 298.33 528.78 383.14",
    fill: "#2c7be5"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    points: "528.78 383.14 528.78 298.33 520.48 383.14 528.78 383.14",
    fill: "#2c7be5"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 376.31,
    y: 293.52,
    width: 23.02,
    height: 12.1,
    fill: "#2c7be5"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 377.74,
    y: 289.72,
    width: 20.16,
    height: 4.05,
    fill: "#2c7be5"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 379.04,
    y: 286.09,
    width: 17.57,
    height: 3.63,
    fill: "#2c7be5"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 380.33,
    y: 282.46,
    width: 14.99,
    height: 3.63,
    fill: "#2c7be5"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 381.69,
    y: 278.83,
    width: 12.27,
    height: 3.63,
    fill: "#2c7be5"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 383.35,
    y: 275.19,
    width: 8.93,
    height: 3.63,
    fill: "#2c7be5"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 376.31,
    y: 293.52,
    width: 11.76,
    height: 12.1,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 377.74,
    y: 289.72,
    width: 10.33,
    height: 3.8,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 379.04,
    y: 286.09,
    width: 9.04,
    height: 3.63,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 380.33,
    y: 282.46,
    width: 7.75,
    height: 3.63,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 381.69,
    y: 278.83,
    width: 6.39,
    height: 3.63,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 383.35,
    y: 275.19,
    width: 3.93,
    height: 3.63,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 384.71,
    y: 275.39,
    width: 6.23,
    height: 10.63,
    rx: 2.35,
    fill: "#2c7be5"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 384.79,
    y: 271.56,
    width: 6.06,
    height: 3.63,
    fill: "#2c7be5"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 386.16,
    y: 267.93,
    width: 3.33,
    height: 3.63,
    fill: "#2c7be5"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 382.79,
    y: 279.31,
    width: 10.06,
    height: 17.18,
    rx: 3.8,
    fill: "#2c7be5"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 382.79,
    y: 279.73,
    width: 10.06,
    height: 17.18,
    rx: 3.8,
    fill: "#2c7be5"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 381.47,
    y: 282.79,
    width: 12.7,
    height: 21.7,
    rx: 4.8,
    fill: "#2c7be5"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 381.47,
    y: 283.18,
    width: 12.7,
    height: 21.7,
    rx: 4.8,
    fill: "#2c7be5"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 380.27,
    y: 286.41,
    width: 15.11,
    height: 25.81,
    rx: 5.71,
    fill: "#2c7be5"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 380.27,
    y: 286.82,
    width: 15.11,
    height: 25.81,
    rx: 5.71,
    fill: "#2c7be5"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 379.11,
    y: 289.72,
    width: 17.42,
    height: 29.76,
    rx: 6.58,
    fill: "#2c7be5"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 379.11,
    y: 290.11,
    width: 17.42,
    height: 29.76,
    rx: 6.58,
    fill: "#2c7be5"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 382.61,
    y: 292.45,
    width: 10.43,
    height: 22.64,
    rx: 3.94,
    fill: "#2c7be5"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 385.83,
    y: 295.41,
    width: 3.83,
    height: 14.2,
    rx: 1.45,
    fill: "#2c7be5"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 367.41,
    y: 359.54,
    width: 40.78,
    height: 23.6,
    fill: "#2c7be5"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 370.79,
    y: 355,
    width: 34.07,
    height: 5.06,
    fill: "#2c7be5"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 372.26,
    y: 350.98,
    width: 31.12,
    height: 5.19,
    fill: "#2c7be5"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 375.1,
    y: 305.63,
    width: 25.44,
    height: 44.61,
    fill: "#2c7be5"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 372.72,
    y: 305.63,
    width: 30.21,
    height: 1.12,
    fill: "#2c7be5"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 376.31,
    y: 307.14,
    width: 4.78,
    height: 42.36,
    fill: "#2c7be5"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 394.55,
    y: 307.14,
    width: 4.78,
    height: 42.36,
    fill: "#2c7be5"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 382.93,
    y: 307.2,
    width: 2.53,
    height: 42.36,
    fill: "#2c7be5"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 384.89,
    y: 307.2,
    width: 0.57,
    height: 42.36,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 372.98,
    y: 351.85,
    width: 29.32,
    height: 1.27,
    fill: "#2c7be5"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 372.98,
    y: 351.85,
    width: 29.32,
    height: 0.28,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 372.98,
    y: 353.73,
    width: 29.32,
    height: 1.27,
    fill: "#2c7be5"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 372.98,
    y: 353.73,
    width: 29.32,
    height: 0.28,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 371.68,
    y: 355.43,
    width: 32.19,
    height: 1.27,
    fill: "#2c7be5"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 371.68,
    y: 355.43,
    width: 32.19,
    height: 0.28,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 371.68,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 371.68,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 378.33,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 378.33,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 381.65,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 381.65,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 384.98,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 384.98,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 388.31,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 388.31,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 391.63,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 391.63,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 394.96,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 394.96,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 398.28,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 398.28,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 401.61,
    y: 357.08,
    width: 2.22,
    height: 2.45,
    fill: "#2c7be5"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 401.61,
    y: 357.08,
    width: 0.5,
    height: 2.45,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 368.29,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 368.29,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 371.61,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 371.61,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 374.94,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 374.94,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 378.26,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 378.26,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 381.59,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 381.59,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 384.92,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 384.92,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 388.24,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 388.24,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 391.57,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 391.57,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 394.89,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 394.89,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 398.22,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 398.22,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 401.61,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 401.61,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 404.93,
    y: 362.08,
    width: 2.22,
    height: 1.61,
    fill: "#2c7be5"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 404.93,
    y: 362.08,
    width: 0.5,
    height: 1.61,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 368.34,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 368.34,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 371.66,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 371.66,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 374.99,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 374.99,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 378.31,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 378.31,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 381.64,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 381.64,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 384.96,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 384.96,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 388.29,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 388.29,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 391.61,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 391.61,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 394.94,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 394.94,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 401.65,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 401.65,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 404.98,
    y: 364.85,
    width: 2.22,
    height: 15.48,
    fill: "#2c7be5"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 404.98,
    y: 364.85,
    width: 0.5,
    height: 15.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 386.72,
    y: 307.2,
    width: 2.21,
    height: 42.36,
    fill: "#2c7be5"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 388.43,
    y: 307.2,
    width: 0.5,
    height: 42.36,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 390.32,
    y: 307.2,
    width: 2.21,
    height: 42.36,
    fill: "#2c7be5"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 392.04,
    y: 307.2,
    width: 0.5,
    height: 42.36,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 370.45,
    y: 349.55,
    width: 34.75,
    height: 1.69,
    fill: "#2c7be5"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 383.61,
    y: 303.11,
    width: 1.17,
    height: 2.15,
    fill: "#2c7be5"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 383.61,
    y: 300.35,
    width: 1.17,
    height: 2.15,
    fill: "#2c7be5"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 383.61,
    y: 297.6,
    width: 1.17,
    height: 2.15,
    fill: "#2c7be5"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 390.84,
    y: 303.11,
    width: 1.17,
    height: 2.15,
    fill: "#2c7be5"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 390.84,
    y: 300.35,
    width: 1.17,
    height: 2.15,
    fill: "#2c7be5"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 390.84,
    y: 297.6,
    width: 1.17,
    height: 2.15,
    fill: "#2c7be5"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    points: "375.1 308.07 375.1 308.08 375.1 349.5 376.31 349.5 376.31 308.08 400.54 308.08 400.54 306.75 375.1 306.75 375.1 308.07",
    fill: "#2c7be5",
    opacity: 0.2
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.93 289.38 388.72 289.38 387.82 288.17 386.93 289.38",
    fill: "#2c7be5"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.59 289.7 386.32 289.43 384.89 288.4 384.59 289.7",
    fill: "#2c7be5"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.81 290.28 384.06 289.82 382.48 289.2 382.81 290.28",
    fill: "#2c7be5"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    points: "381.61 290.84 382.44 290.44 381.2 290.09 381.61 290.84",
    fill: "#2c7be5"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    points: "389.32 289.43 391.05 289.7 390.74 288.4 389.32 289.43",
    fill: "#2c7be5"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.83 290.28 393.16 289.2 391.57 289.82 392.83 290.28",
    fill: "#2c7be5"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.02 290.84 394.44 290.09 393.2 290.44 394.02 290.84",
    fill: "#2c7be5"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.03 286.14 388.61 286.14 387.82 285.08 387.03 286.14",
    fill: "#2c7be5"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.97 286.43 386.5 286.19 385.24 285.28 384.97 286.43",
    fill: "#2c7be5"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    points: "383.4 286.94 384.51 286.53 383.11 285.99 383.4 286.94",
    fill: "#2c7be5"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.35 287.43 383.08 287.08 381.99 286.77 382.35 287.43",
    fill: "#2c7be5"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    points: "389.14 286.19 390.66 286.43 390.39 285.28 389.14 286.19",
    fill: "#2c7be5"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.23 286.94 392.52 285.99 391.12 286.53 392.23 286.94",
    fill: "#2c7be5"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.28 287.43 393.65 286.77 392.56 287.08 393.28 287.43",
    fill: "#2c7be5"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.28 282.43 388.52 282.43 387.9 281.6 387.28 282.43",
    fill: "#2c7be5"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    points: "385.68 282.65 386.87 282.46 385.89 281.75 385.68 282.65",
    fill: "#2c7be5"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.45 283.05 385.32 282.73 384.23 282.31 384.45 283.05",
    fill: "#2c7be5"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    points: "383.63 283.43 384.2 283.16 383.35 282.92 383.63 283.43",
    fill: "#2c7be5"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    points: "388.93 282.46 390.12 282.65 389.91 281.75 388.93 282.46",
    fill: "#2c7be5"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.34 283.05 391.57 282.31 390.48 282.73 391.34 283.05",
    fill: "#2c7be5"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.16 283.43 392.45 282.92 391.6 283.16 392.16 283.43",
    fill: "#2c7be5"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.38 279.06 388.23 279.06 387.81 278.56 387.38 279.06",
    fill: "#2c7be5"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.27 279.19 387.09 279.08 386.41 278.65 386.27 279.19",
    fill: "#2c7be5"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    points: "385.42 279.44 386.02 279.25 385.26 278.99 385.42 279.44",
    fill: "#2c7be5"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    points: "388.52 279.08 389.34 279.19 389.2 278.65 388.52 279.08",
    fill: "#2c7be5"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    points: "390.19 279.44 390.35 278.99 389.59 279.25 390.19 279.44",
    fill: "#2c7be5"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 384.79,
    y: 271.56,
    width: 2.48,
    height: 3.63,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 386.16,
    y: 267.93,
    width: 1.1,
    height: 3.63,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 366.98,
    y: 359.54,
    width: 41.59,
    height: 0.52,
    fill: "#2c7be5"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.74 267.93 388.87 267.93 387.81 253.55 386.74 267.93",
    fill: "#2c7be5"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 202.35,
    y: 350.41,
    width: 48.38,
    height: 41.09,
    fill: "#2c7be5"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 206.58,
    y: 319.36,
    width: 39.99,
    height: 31.05,
    fill: "#2c7be5"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 210.84,
    y: 315.33,
    width: 31.48,
    height: 4.03,
    fill: "#2c7be5"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 206.58,
    y: 319.36,
    width: 4.25,
    height: 5.24,
    fill: "#2c7be5"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.55 391.5 250.74 391.5 202.59 386.45 202.55 391.5",
    fill: "#2c7be5"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 242.31,
    y: 319.36,
    width: 4.25,
    height: 5.24,
    fill: "#2c7be5"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 210.84,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 208.71,
    y: 324.59,
    width: 0.49,
    height: 66.91,
    fill: "#2c7be5"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 206.58,
    y: 324.6,
    width: 0.49,
    height: 66.91,
    fill: "#2c7be5"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 204.45,
    y: 350.45,
    width: 0.49,
    height: 41.05,
    fill: "#2c7be5"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 202.33,
    y: 350.45,
    width: 0.49,
    height: 41.05,
    fill: "#2c7be5"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 243.87,
    y: 324.59,
    width: 0.49,
    height: 66.91,
    fill: "#2c7be5"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 324.6,
    width: 0.49,
    height: 66.91,
    fill: "#2c7be5"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 248.12,
    y: 350.45,
    width: 0.49,
    height: 41.05,
    fill: "#2c7be5"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 250.25,
    y: 350.45,
    width: 0.49,
    height: 41.05,
    fill: "#2c7be5"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 212.78,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 214.72,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 216.66,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 218.6,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 220.54,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 222.48,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 224.42,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 226.36,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 228.3,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 230.24,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 232.18,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 234.12,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 236.06,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 239.94,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 241.89,
    y: 319.36,
    width: 0.49,
    height: 72.14,
    fill: "#2c7be5"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 214.74,
    y: 312.57,
    width: 24.09,
    height: 2.77,
    fill: "#2c7be5"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.54 308.32 214.74 312.57 238.83 312.57 235.02 308.32 218.54 308.32",
    fill: "#2c7be5"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 410.68,
    y: 349.17,
    width: 29.99,
    height: 42.33,
    fill: "#2c7be5"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 412.93,
    y: 345.73,
    width: 25.48,
    height: 4.03,
    fill: "#2c7be5"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 416.51,
    y: 343.72,
    width: 18.32,
    height: 2.02,
    fill: "#2c7be5"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 419.69,
    y: 341.7,
    width: 11.97,
    height: 2.39,
    fill: "#2c7be5"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 349.41,
    y: 296.81,
    width: 25.23,
    height: 94.69,
    fill: "#2c7be5"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 349.41,
    y: 296.81,
    width: 25.23,
    height: 94.69,
    opacity: 0.58,
    fill: "url(#linear-gradient-14)"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 351.3,
    y: 289.12,
    width: 21.44,
    height: 8.39,
    fill: "#2c7be5"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 354.31,
    y: 284.62,
    width: 15.41,
    height: 5.05,
    fill: "#2c7be5"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 356.99,
    y: 280.11,
    width: 10.07,
    height: 5.16,
    fill: "#2c7be5"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 351.3,
    y: 289.12,
    width: 21.44,
    height: 8.39,
    opacity: 0.58,
    fill: "url(#linear-gradient-15)"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 354.31,
    y: 284.62,
    width: 15.41,
    height: 5.05,
    opacity: 0.58,
    fill: "url(#linear-gradient-16)"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 356.99,
    y: 280.11,
    width: 10.07,
    height: 5.16,
    opacity: 0.58,
    fill: "url(#linear-gradient-17)"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.25 149.71 334.11 149.71 331.68 122.77 329.25 149.71",
    fill: "#2c7be5"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.25 149.71 334.11 149.71 331.68 122.77 329.25 149.71",
    fill: "url(#linear-gradient-18)"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 316.73,
    y: 156.09,
    width: 29.64,
    height: 7.9,
    fill: "#2c7be5"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 316.73,
    y: 156.09,
    width: 29.64,
    height: 7.9,
    opacity: 0.58,
    fill: "url(#linear-gradient-19)"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.14 163.37 302.14 391.5 361.22 391.5 361.22 163.37 331.71 159.91 302.14 163.37",
    fill: "#2c7be5"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.14 163.37 302.14 391.5 361.22 391.5 361.22 163.37 331.71 159.91 302.14 163.37",
    fill: "url(#linear-gradient-20)"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.14 391.5 361.28 391.5 331.71 159.91 302.14 391.5",
    fill: "#2c7be5"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.14 391.5 361.28 391.5 331.71 159.91 302.14 391.5",
    opacity: 0.58,
    fill: "url(#linear-gradient-21)"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.14 391.5 331.71 159.91 302.14 163.37 302.14 391.5",
    fill: "#2c7be5"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.14 391.5 331.71 159.91 302.14 163.37 302.14 391.5",
    fill: "url(#linear-gradient-22)"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 323.53,
    y: 149.55,
    width: 15.76,
    height: 6.54,
    fill: "#2c7be5"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 323.53,
    y: 149.55,
    width: 15.76,
    height: 6.54,
    fill: "url(#linear-gradient-23)"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.41 279.69 302.14 391.5 361.28 391.5 347 279.69 316.41 279.69",
    fill: "#2c7be5"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.41 279.69 302.14 391.5 361.28 391.5 347 279.69 316.41 279.69",
    opacity: 0.58,
    fill: "url(#linear-gradient-24)"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 374.74,
    y: 224.16,
    width: 35.12,
    height: 37.88,
    fill: "#2c7be5"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 374.74,
    y: 224.16,
    width: 35.12,
    height: 37.88,
    opacity: 0.58,
    fill: "url(#linear-gradient-25)"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 369.83,
    y: 261.94,
    width: 44.94,
    height: 129.56,
    fill: "#2c7be5"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 369.83,
    y: 261.94,
    width: 44.94,
    height: 129.56,
    opacity: 0.58,
    fill: "url(#linear-gradient-26)"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 371.7,
    y: 239.78,
    width: 14.81,
    height: 22.17,
    fill: "#2c7be5"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 398.33,
    y: 239.78,
    width: 14.81,
    height: 22.17,
    fill: "#2c7be5"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 371.7,
    y: 239.78,
    width: 14.81,
    height: 22.17,
    opacity: 0.58,
    fill: "url(#linear-gradient-27)"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 398.33,
    y: 239.78,
    width: 14.81,
    height: 22.17,
    opacity: 0.58,
    fill: "url(#linear-gradient-28)"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 386.5,
    y: 261.94,
    width: 11.79,
    height: 129.56,
    fill: "#2c7be5"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 377.82,
    y: 215.67,
    width: 28.96,
    height: 4.35,
    fill: "#2c7be5"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 377.82,
    y: 215.67,
    width: 28.96,
    height: 4.35,
    opacity: 0.58,
    fill: "url(#linear-gradient-29)"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 380.36,
    y: 212.08,
    width: 23.88,
    height: 3.59,
    fill: "#2c7be5"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 380.36,
    y: 212.08,
    width: 23.88,
    height: 3.59,
    opacity: 0.58,
    fill: "url(#linear-gradient-30)"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 383.03,
    y: 209.3,
    width: 18.55,
    height: 2.78,
    fill: "#2c7be5"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 383.03,
    y: 209.3,
    width: 18.55,
    height: 2.78,
    opacity: 0.58,
    fill: "url(#linear-gradient-31)"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 385.31,
    y: 207.2,
    width: 13.97,
    height: 2.25,
    fill: "#2c7be5"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 388.72,
    y: 186.64,
    width: 7.16,
    height: 5.07,
    fill: "#2c7be5"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.02 186.9 393.58 186.9 392.3 144.18 391.02 186.9",
    fill: "#2c7be5"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 386.89,
    y: 191.71,
    width: 10.82,
    height: 25.77,
    fill: "#2c7be5"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 386.89,
    y: 191.71,
    width: 10.82,
    height: 25.77,
    opacity: 0.58,
    fill: "url(#linear-gradient-32)"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 390.29,
    y: 193.38,
    width: 4.03,
    height: 26.56,
    fill: "#2c7be5"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 375.7,
    y: 220.01,
    width: 33.05,
    height: 4.19,
    fill: "#2c7be5"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 375.7,
    y: 220.01,
    width: 33.05,
    height: 4.19,
    opacity: 0.58,
    fill: "url(#linear-gradient-33)"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 394.64,
    y: 186.64,
    width: 1.24,
    height: 5.07,
    fill: "#2c7be5"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 395.78,
    y: 191.71,
    width: 1.94,
    height: 15.47,
    fill: "#2c7be5"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 388.72,
    y: 186.64,
    width: 1.24,
    height: 5.07,
    fill: "#2c7be5"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 385.31,
    y: 207.23,
    width: 1.24,
    height: 2.07,
    fill: "#2c7be5"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 383.03,
    y: 209.3,
    width: 1.24,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 380.36,
    y: 212.06,
    width: 1.24,
    height: 3.61,
    fill: "#2c7be5"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 377.82,
    y: 215.68,
    width: 1.24,
    height: 4.3,
    fill: "#2c7be5"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 398.05,
    y: 207.23,
    width: 1.24,
    height: 2.07,
    fill: "#2c7be5"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 400.33,
    y: 209.3,
    width: 1.24,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 212.06,
    width: 1.24,
    height: 3.61,
    fill: "#2c7be5"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 405.54,
    y: 215.68,
    width: 1.24,
    height: 4.3,
    fill: "#2c7be5"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 386.89,
    y: 191.71,
    width: 1.24,
    height: 15.51,
    fill: "#2c7be5"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 400.7,
    y: 242.34,
    width: 2.22,
    height: 19.57,
    fill: "#2c7be5"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 404.82,
    y: 242.34,
    width: 2.22,
    height: 19.6,
    fill: "#2c7be5"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 408.95,
    y: 242.34,
    width: 2.22,
    height: 19.6,
    fill: "#2c7be5"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 402.36,
    y: 242.34,
    width: 0.55,
    height: 19.57,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 406.49,
    y: 242.34,
    width: 0.55,
    height: 19.6,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 410.55,
    y: 242.34,
    width: 0.62,
    height: 19.6,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 373.88,
    y: 242.33,
    width: 2.22,
    height: 19.57,
    fill: "#2c7be5"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 242.33,
    width: 2.22,
    height: 19.6,
    fill: "#2c7be5"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 382.12,
    y: 242.33,
    width: 2.22,
    height: 19.6,
    fill: "#2c7be5"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 375.54,
    y: 242.33,
    width: 0.55,
    height: 19.57,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 379.67,
    y: 242.33,
    width: 0.55,
    height: 19.6,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 383.72,
    y: 242.33,
    width: 0.62,
    height: 19.6,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 400.7,
    y: 227.82,
    width: 2.22,
    height: 11.94,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 404.82,
    y: 227.82,
    width: 2.22,
    height: 11.96,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 402.36,
    y: 227.82,
    width: 0.55,
    height: 11.94,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 406.49,
    y: 227.82,
    width: 0.55,
    height: 11.96,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 227.8,
    width: 2.22,
    height: 11.96,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 382.12,
    y: 227.8,
    width: 2.22,
    height: 11.96,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 379.67,
    y: 227.8,
    width: 0.55,
    height: 11.96,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 383.72,
    y: 227.8,
    width: 0.62,
    height: 11.96,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 372.24,
    y: 264.32,
    width: 2.56,
    height: 127.18,
    fill: "#2c7be5"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 377.01,
    y: 264.32,
    width: 2.56,
    height: 127.18,
    fill: "#2c7be5"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 381.78,
    y: 264.32,
    width: 2.56,
    height: 127.18,
    fill: "#2c7be5"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 374.17,
    y: 264.32,
    width: 0.64,
    height: 127.18,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 378.93,
    y: 264.32,
    width: 0.64,
    height: 127.18,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 383.63,
    y: 264.32,
    width: 0.71,
    height: 127.18,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 400.71,
    y: 264.31,
    width: 2.56,
    height: 127.19,
    fill: "#2c7be5"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 264.31,
    width: 2.56,
    height: 127.19,
    fill: "#2c7be5"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 410.25,
    y: 264.31,
    width: 2.56,
    height: 127.19,
    fill: "#2c7be5"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 402.64,
    y: 264.31,
    width: 0.64,
    height: 127.19,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 407.41,
    y: 264.31,
    width: 0.64,
    height: 127.19,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 412.1,
    y: 264.31,
    width: 0.71,
    height: 127.19,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 397.48,
    y: 239.73,
    width: 0.97,
    height: 151.77,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 387.79,
    y: 227.88,
    width: 1.99,
    height: 163.62,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 391.49,
    y: 227.88,
    width: 1.99,
    height: 163.62,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 391.49,
    y: 227.88,
    width: 1.99,
    height: 163.62,
    fill: "url(#linear-gradient-34)"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 395.2,
    y: 227.88,
    width: 1.99,
    height: 163.62,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 389.28,
    y: 227.88,
    width: 0.5,
    height: 163.62,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 392.99,
    y: 227.88,
    width: 0.5,
    height: 163.62,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 396.63,
    y: 227.88,
    width: 0.55,
    height: 163.62,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 377.82,
    y: 221.79,
    width: 1.85,
    height: 2.4,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 382.35,
    y: 221.79,
    width: 1.85,
    height: 2.4,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 386.88,
    y: 221.79,
    width: 1.85,
    height: 2.4,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 391.41,
    y: 221.79,
    width: 1.85,
    height: 2.4,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 395.95,
    y: 221.79,
    width: 1.85,
    height: 2.4,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 400.48,
    y: 221.79,
    width: 1.85,
    height: 2.4,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 405.01,
    y: 221.79,
    width: 1.85,
    height: 2.4,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 449.92,
    y: 341.7,
    width: 29.99,
    height: 49.8,
    fill: "#2c7be5"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 449.92,
    y: 341.7,
    width: 29.99,
    height: 49.8,
    opacity: 0.58,
    fill: "url(#linear-gradient-35)"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 452.17,
    y: 337.66,
    width: 25.48,
    height: 4.69,
    fill: "#2c7be5"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 452.17,
    y: 337.66,
    width: 25.48,
    height: 4.69,
    opacity: 0.58,
    fill: "url(#linear-gradient-36)"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 458.93,
    y: 332.91,
    width: 11.97,
    height: 2.8,
    fill: "#2c7be5"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 458.93,
    y: 332.91,
    width: 11.97,
    height: 2.41,
    opacity: 0.58,
    fill: "url(#linear-gradient-37)"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    points: "458.93 335.35 455.76 335.35 455.76 337.78 452.17 337.78 452.17 341.7 449.92 341.7 449.92 391.5 461.94 391.5 461.94 332.91 458.93 332.91 458.93 335.35",
    fill: "#2c7be5"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    points: "458.93 335.35 455.76 335.35 455.76 337.78 452.17 337.78 452.17 341.7 449.92 341.7 449.92 391.5 461.94 391.5 461.94 332.91 458.93 332.91 458.93 335.35",
    opacity: 0.58,
    fill: "url(#linear-gradient-38)"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 455.76,
    y: 335.28,
    width: 18.32,
    height: 2.8,
    opacity: 0.58,
    fill: "url(#linear-gradient-39)"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 461.89,
    y: 335.28,
    width: 12.18,
    height: 2.8,
    opacity: 0.58,
    fill: "url(#linear-gradient-40)"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 278.36,
    y: 336.05,
    width: 61.62,
    height: 55.45,
    fill: "#2c7be5"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 278.36,
    y: 336.05,
    width: 61.62,
    height: 55.45,
    opacity: 0.58,
    fill: "url(#linear-gradient-41)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.2,
    cy: 288.58,
    rx: 16.18,
    ry: 8.47,
    fill: "#2c7be5"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 283.74,
    y: 294.14,
    width: 50.92,
    height: 41.91,
    fill: "#2c7be5"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 283.74,
    y: 294.14,
    width: 50.92,
    height: 41.91,
    opacity: 0.58,
    fill: "url(#linear-gradient-42)"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    points: "283.74 336.05 334.66 336.05 283.74 330.01 283.74 336.05",
    fill: "#2c7be5"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    points: "283.74 336.05 334.66 336.05 283.74 330.01 283.74 336.05",
    opacity: 0.58,
    fill: "url(#linear-gradient-43)"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    points: "278.53 353.09 339.97 353.09 278.53 347.14 278.53 353.09",
    opacity: 0.58,
    fill: "url(#linear-gradient-44)"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 289.16,
    y: 288.71,
    width: 40.09,
    height: 5.43,
    fill: "#2c7be5"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 275.78,
    y: 353.09,
    width: 66.85,
    height: 38.41,
    fill: "#2c7be5"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 275.78,
    y: 353.09,
    width: 66.85,
    height: 38.41,
    opacity: 0.58,
    fill: "url(#linear-gradient-45)"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 283.74,
    y: 294.14,
    width: 5.42,
    height: 7.07,
    fill: "#2c7be5"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.74 391.5 342.63 391.5 275.78 384.64 275.74 391.5",
    fill: "#2c7be5"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 329.25,
    y: 294.14,
    width: 5.42,
    height: 7.07,
    fill: "#2c7be5"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 289.16,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 286.45,
    y: 301.2,
    width: 0.62,
    height: 90.3,
    fill: "#2c7be5"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 283.74,
    y: 301.2,
    width: 0.62,
    height: 90.3,
    fill: "#2c7be5"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 281.03,
    y: 336.1,
    width: 0.62,
    height: 55.4,
    fill: "#2c7be5"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 278.33,
    y: 336.1,
    width: 0.62,
    height: 55.4,
    fill: "#2c7be5"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 331.23,
    y: 301.2,
    width: 0.62,
    height: 90.3,
    fill: "#2c7be5"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 333.93,
    y: 301.2,
    width: 0.62,
    height: 90.3,
    fill: "#2c7be5"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 336.64,
    y: 336.1,
    width: 0.62,
    height: 55.4,
    fill: "#2c7be5"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 339.35,
    y: 336.1,
    width: 0.62,
    height: 55.4,
    fill: "#2c7be5"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 291.63,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 294.1,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 296.57,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 299.05,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 301.52,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 303.99,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 306.46,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 308.93,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 311.4,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 313.87,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 316.34,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 318.82,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 321.29,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 323.76,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 326.23,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 328.7,
    y: 294.14,
    width: 0.62,
    height: 97.36,
    fill: "#2c7be5"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.67 391.5 435.67 391.5 435.67 294.22 425.67 301.74 425.67 391.5",
    fill: "#2c7be5"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.67 391.5 455.68 391.5 455.68 301.74 435.67 294.22 435.67 391.5",
    fill: "#2c7be5"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.67 391.5 455.68 391.5 455.68 301.74 435.67 294.22 435.67 391.5",
    opacity: 0.58,
    fill: "url(#linear-gradient-46)"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.67 391.5 435.67 294.22 425.67 391.5 435.67 391.5",
    fill: "#2c7be5"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 251.83,
    y: 239.68,
    width: 27.75,
    height: 20.51,
    fill: "#2c7be5"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 253.55,
    y: 233.23,
    width: 24.31,
    height: 6.87,
    fill: "#2c7be5"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 255.12,
    y: 227.08,
    width: 21.18,
    height: 6.15,
    fill: "#2c7be5"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 256.67,
    y: 220.93,
    width: 18.08,
    height: 6.15,
    fill: "#2c7be5"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 258.31,
    y: 214.78,
    width: 14.79,
    height: 6.15,
    fill: "#2c7be5"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 260.32,
    y: 208.62,
    width: 10.77,
    height: 6.15,
    fill: "#2c7be5"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 251.83,
    y: 239.68,
    width: 14.18,
    height: 20.51,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 253.55,
    y: 233.23,
    width: 12.46,
    height: 6.44,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 255.12,
    y: 227.08,
    width: 10.9,
    height: 6.15,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 256.67,
    y: 220.93,
    width: 9.34,
    height: 6.15,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 258.31,
    y: 214.78,
    width: 7.7,
    height: 6.15,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 260.32,
    y: 208.62,
    width: 4.73,
    height: 6.15,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 261.95,
    y: 208.95,
    width: 7.51,
    height: 18.02,
    rx: 3.36,
    fill: "#2c7be5"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 262.05,
    y: 202.47,
    width: 7.3,
    height: 6.15,
    fill: "#2c7be5"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 263.7,
    y: 196.32,
    width: 4.02,
    height: 6.15,
    fill: "#2c7be5"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 259.64,
    y: 215.6,
    width: 12.13,
    height: 29.11,
    rx: 5.43,
    fill: "#2c7be5"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 259.64,
    y: 216.31,
    width: 12.13,
    height: 29.11,
    rx: 5.43,
    fill: "#2c7be5"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 258.05,
    y: 221.49,
    width: 15.32,
    height: 36.77,
    rx: 6.86,
    fill: "#2c7be5"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 258.05,
    y: 222.15,
    width: 15.32,
    height: 36.77,
    rx: 6.86,
    fill: "#2c7be5"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 256.6,
    y: 227.63,
    width: 18.22,
    height: 43.72,
    rx: 8.16,
    fill: "#2c7be5"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 256.6,
    y: 228.32,
    width: 18.22,
    height: 43.72,
    rx: 8.16,
    fill: "#2c7be5"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 255.2,
    y: 233.23,
    width: 21.01,
    height: 50.42,
    rx: 9.41,
    fill: "#2c7be5"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 255.2,
    y: 233.89,
    width: 21.01,
    height: 50.42,
    rx: 9.41,
    fill: "#2c7be5"
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 259.42,
    y: 237.85,
    width: 12.58,
    height: 38.36,
    rx: 5.63,
    fill: "#2c7be5"
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 263.3,
    y: 242.86,
    width: 4.62,
    height: 24.06,
    rx: 2.07,
    fill: "#2c7be5"
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 241.1,
    y: 351.51,
    width: 49.17,
    height: 39.99,
    fill: "#2c7be5"
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 241.1,
    y: 351.51,
    width: 49.17,
    height: 39.99,
    opacity: 0.58,
    fill: "url(#linear-gradient-47)"
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 246.94,
    y: 337.01,
    width: 37.52,
    height: 8.79,
    fill: "#2c7be5"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 250.37,
    y: 260.18,
    width: 30.68,
    height: 75.58,
    fill: "#2c7be5"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 250.37,
    y: 260.18,
    width: 30.68,
    height: 75.58,
    opacity: 0.58,
    fill: "url(#linear-gradient-48)"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 247.49,
    y: 260.18,
    width: 36.43,
    height: 1.9,
    fill: "#2c7be5"
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 251.83,
    y: 262.74,
    width: 5.76,
    height: 71.76,
    fill: "#2c7be5"
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 273.82,
    y: 262.74,
    width: 5.76,
    height: 71.76,
    fill: "#2c7be5"
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 259.8,
    y: 262.85,
    width: 3.05,
    height: 71.76,
    fill: "#2c7be5"
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 262.17,
    y: 262.85,
    width: 0.68,
    height: 71.76,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 247.81,
    y: 338.49,
    width: 35.36,
    height: 2.15,
    fill: "#2c7be5"
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 247.81,
    y: 338.49,
    width: 35.36,
    height: 0.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 247.81,
    y: 341.67,
    width: 35.36,
    height: 2.15,
    fill: "#2c7be5"
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 247.81,
    y: 341.67,
    width: 35.36,
    height: 0.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 246.24,
    y: 344.55,
    width: 38.81,
    height: 0.48,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 246.24,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 246.24,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 250.25,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 250.25,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 254.26,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 254.26,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 258.27,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: 258.27,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 262.28,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 262.28,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 266.29,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 266.29,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 270.3,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 270.3,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 274.31,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 274.31,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 278.32,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 278.32,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 282.33,
    y: 347.35,
    width: 2.68,
    height: 4.16,
    fill: "#2c7be5"
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 282.33,
    y: 347.35,
    width: 0.6,
    height: 4.16,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 242.15,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 242.15,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 246.16,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 246.16,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 250.17,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: 250.17,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 254.18,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 254.18,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 258.19,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 258.19,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 262.2,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 262.2,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 266.21,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 266.21,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 270.22,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 270.22,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 274.23,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 274.23,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 278.24,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 278.24,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 282.33,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 282.33,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: 286.34,
    y: 355.82,
    width: 2.68,
    height: 2.72,
    fill: "#2c7be5"
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 286.34,
    y: 355.82,
    width: 0.6,
    height: 2.72,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 242.21,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 242.21,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 246.22,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 246.22,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 250.23,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 250.23,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 254.24,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 254.24,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 258.25,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 258.25,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 262.26,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 262.26,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 266.27,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 266.27,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 270.28,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 270.28,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    x: 274.29,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    x: 274.29,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    x: 278.3,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    x: 278.3,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    x: 282.39,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    x: 282.39,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    x: 286.4,
    y: 360.51,
    width: 2.68,
    height: 26.23,
    fill: "#2c7be5"
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    x: 286.4,
    y: 360.51,
    width: 0.6,
    height: 26.23,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    x: 264.37,
    y: 262.85,
    width: 2.67,
    height: 71.76,
    fill: "#2c7be5"
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    x: 266.44,
    y: 262.85,
    width: 0.6,
    height: 71.76,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    x: 268.72,
    y: 262.85,
    width: 2.67,
    height: 71.76,
    fill: "#2c7be5"
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    x: 270.79,
    y: 262.85,
    width: 0.6,
    height: 71.76,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    x: 244.75,
    y: 334.59,
    width: 41.91,
    height: 2.86,
    fill: "#2c7be5"
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    x: 246.94,
    y: 337.01,
    width: 37.52,
    height: 8.79,
    fill: "#2c7be5"
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    x: 246.94,
    y: 337.01,
    width: 37.52,
    height: 8.79,
    opacity: 0.58,
    fill: "url(#linear-gradient-49)"
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    x: 244.75,
    y: 334.59,
    width: 41.91,
    height: 2.86,
    fill: "#2c7be5"
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    x: 244.75,
    y: 334.59,
    width: 41.91,
    height: 2.86,
    opacity: 0.58,
    fill: "url(#linear-gradient-50)"
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    x: 260.62,
    y: 255.91,
    width: 1.41,
    height: 3.64,
    fill: "#2c7be5"
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    x: 260.62,
    y: 251.25,
    width: 1.41,
    height: 3.64,
    fill: "#2c7be5"
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    x: 260.62,
    y: 246.58,
    width: 1.41,
    height: 3.64,
    fill: "#2c7be5"
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    x: 269.35,
    y: 255.91,
    width: 1.41,
    height: 3.64,
    fill: "#2c7be5"
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    x: 269.35,
    y: 251.25,
    width: 1.41,
    height: 3.64,
    fill: "#2c7be5"
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    x: 269.35,
    y: 246.58,
    width: 1.41,
    height: 3.64,
    fill: "#2c7be5"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    points: "250.37 264.32 250.37 264.33 250.37 334.5 251.82 334.5 251.82 264.33 281.04 264.33 281.04 262.09 250.37 262.09 250.37 264.32",
    fill: "#2c7be5",
    opacity: 0.2
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.62 232.65 266.79 232.65 265.71 230.6 264.62 232.65",
    fill: "#2c7be5"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.81 233.19 263.89 232.73 262.17 230.99 261.81 233.19",
    fill: "#2c7be5"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    points: "259.66 234.18 261.17 233.4 259.26 232.36 259.66 234.18",
    fill: "#2c7be5"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.22 235.13 259.21 234.46 257.72 233.85 258.22 235.13",
    fill: "#2c7be5"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.51 232.73 269.59 233.19 269.23 230.99 267.51 232.73",
    fill: "#2c7be5"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.74 234.18 272.14 232.36 270.23 233.4 271.74 234.18",
    fill: "#2c7be5"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    points: "273.18 235.13 273.68 233.85 272.19 234.46 273.18 235.13",
    fill: "#2c7be5"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.75 227.17 266.66 227.17 265.7 225.37 264.75 227.17",
    fill: "#2c7be5"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.27 227.65 264.11 227.24 262.59 225.71 262.27 227.65",
    fill: "#2c7be5"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.38 228.52 261.71 227.83 260.03 226.91 260.38 228.52",
    fill: "#2c7be5"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    points: "259.11 229.36 259.99 228.76 258.67 228.23 259.11 229.36",
    fill: "#2c7be5"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.29 227.24 269.13 227.65 268.81 225.71 267.29 227.24",
    fill: "#2c7be5"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.02 228.52 271.37 226.91 269.69 227.83 271.02 228.52",
    fill: "#2c7be5"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.29 229.36 272.73 228.23 271.42 228.76 272.29 229.36",
    fill: "#2c7be5"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    points: "265.06 220.88 266.54 220.88 265.8 219.47 265.06 220.88",
    fill: "#2c7be5"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    points: "263.12 221.25 264.55 220.93 263.37 219.73 263.12 221.25",
    fill: "#2c7be5"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.64 221.93 262.69 221.39 261.37 220.67 261.64 221.93",
    fill: "#2c7be5"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.65 222.58 261.34 222.12 260.31 221.7 260.65 222.58",
    fill: "#2c7be5"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.04 220.93 268.47 221.25 268.22 219.73 267.04 220.93",
    fill: "#2c7be5"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.95 221.93 270.22 220.67 268.91 221.39 269.95 221.93",
    fill: "#2c7be5"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.94 222.58 271.28 221.7 270.25 222.12 270.94 222.58",
    fill: "#2c7be5"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    points: "265.17 215.18 266.2 215.18 265.69 214.32 265.17 215.18",
    fill: "#2c7be5"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    points: "263.83 215.4 264.82 215.21 264 214.48 263.83 215.4",
    fill: "#2c7be5"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.81 215.81 263.53 215.49 262.62 215.05 262.81 215.81",
    fill: "#2c7be5"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    points: "266.54 215.21 267.54 215.4 267.36 214.48 266.54 215.21",
    fill: "#2c7be5"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    points: "268.56 215.81 268.75 215.05 267.84 215.49 268.56 215.81",
    fill: "#2c7be5"
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    x: 262.05,
    y: 202.47,
    width: 2.98,
    height: 6.15,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    x: 263.7,
    y: 196.32,
    width: 1.33,
    height: 6.15,
    fill: "#2c7be5",
    opacity: 0.2
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.41 196.32 266.96 196.32 265.69 171.95 264.41 196.32",
    fill: "#2c7be5"
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    x: 245.16,
    y: 343.82,
    width: 41.08,
    height: 8.57,
    fill: "#2c7be5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.09,232.52c-.17,9.28,1.14,12,2.76,11.88s23-20.85,23-20.85l-17.35-11.89S101.25,223.23,101.09,232.52Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.09,232.52c-.17,9.28,1.14,12,2.76,11.88s23-20.85,23-20.85l-17.35-11.89S101.25,223.23,101.09,232.52Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-51)"
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    x: 137.68,
    y: 64.01,
    width: 9.61,
    height: 12.65,
    fill: "#2c7be5"
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    x: 137.68,
    y: 64.01,
    width: 9.61,
    height: 12.65,
    opacity: 0.58,
    fill: "url(#linear-gradient-52)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93,297.18,223,298.51l-8.66,13.08-1.78,7.28s7.28-1.6,8.33-2.56,7.27-13.55,7.38-13.87-1.16-3.08-1.46-3.88A4.42,4.42,0,0,0,225.93,297.18Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.19,354.37s13-6.52,17.48-9.88,6.3-28,6.3-28l-22.58,3.8Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M189.19,354.37s13-6.52,17.48-9.88,6.3-28,6.3-28l-22.58,3.8Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-53)"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.82 179.61 177.38 191.11 179.4 175.84 174.21 171.49 167.82 179.61",
    fill: "#2c7be5"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 173.82 199.88 183.37 201.26 203.71 211.22 202.98 205.73 172.55 199.88 173.82",
    fill: "#2c7be5"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.82 179.61 177.38 191.11 179.4 175.84 174.21 171.49 167.82 179.61",
    opacity: 0.58,
    fill: "url(#linear-gradient-54)"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 173.82 199.88 183.37 201.26 203.71 211.22 202.98 205.73 172.55 199.88 173.82",
    opacity: 0.58,
    fill: "url(#linear-gradient-55)"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.32 145.85 191.08 145.85 189.2 126.26 187.32 145.85",
    fill: "#2c7be5"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.85 163.44 225.44 161.56 205.85 159.68 205.85 163.44",
    fill: "#2c7be5"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.67 163.44 172.67 159.68 153.08 161.56 172.67 163.44",
    fill: "#2c7be5"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    points: "200.2 150.14 212.14 134.5 197.45 147.59 200.2 150.14",
    fill: "#2c7be5"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.49 156.47 222.65 146.83 203.97 153.03 205.49 156.47",
    fill: "#2c7be5"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.27 156.47 173.79 153.03 155.11 146.83 172.27 156.47",
    fill: "#2c7be5"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.47 150.14 180.23 147.59 165.53 134.5 177.47 150.14",
    fill: "#2c7be5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M122.17,190.54c-.58-3.25-5.86-25.76-6-27.93s.07-2.46-.22-6.66-7-9.7-7-9.7l-4.42,13.39s-.5,21.57.22,27.65,2.61,11.29,3.11,14.18,1.74,11.22,2.82,17.59,2.83,15.71,2.83,15.71l17.15-5.94s-6.37-22.58-7.16-25S122.75,193.8,122.17,190.54Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.17,190.54c-.58-3.25-5.86-25.76-6-27.93s.07-2.46-.22-6.66-7-9.7-7-9.7l-4.42,13.39s-.5,21.57.22,27.65,2.61,11.29,3.11,14.18,1.74,11.22,2.82,17.59,2.83,15.71,2.83,15.71l17.15-5.94s-6.37-22.58-7.16-25S122.75,193.8,122.17,190.54Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient-56)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.17,190.54c-.58-3.25-5.86-25.76-6-27.93s0-2.44-.19-6.21c2.27-1.55-.23-13-.83-12.7s-8.73,10.67-9.14,11.4L105,158.33a32.06,32.06,0,0,0-.49,3.89c0,1.2,0,2.73-.07,4.46a4.54,4.54,0,0,0,4.74,4c2.38,0,4.12-4.35,5.32-2.72s5.53,30.62,5.64,36.48-3.36,21.93-3.36,21.93l8-18.45c-.59-2-1-3.5-1.2-4C122.68,201.47,122.75,193.8,122.17,190.54Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.17,190.54c-.58-3.25-5.86-25.76-6-27.93s0-2.44-.19-6.21c2.27-1.55-.23-13-.83-12.7s-8.73,10.67-9.14,11.4L105,158.33a32.06,32.06,0,0,0-.49,3.89c0,1.2,0,2.73-.07,4.46a4.54,4.54,0,0,0,4.74,4c2.38,0,4.12-4.35,5.32-2.72s5.53,30.62,5.64,36.48-3.36,21.93-3.36,21.93l8-18.45c-.59-2-1-3.5-1.2-4C122.68,201.47,122.75,193.8,122.17,190.54Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-57)"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    points: "138.33 110.63 146.65 110.63 147.73 85.74 137.24 85.74 138.33 110.63",
    fill: "#2c7be5"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    points: "138.33 110.63 146.65 110.63 147.73 85.74 137.24 85.74 138.33 110.63",
    opacity: 0.58,
    fill: "url(#linear-gradient-58)"
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    x: 137.91,
    y: 110.34,
    width: 9.08,
    height: 2.42,
    fill: "#2c7be5"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.13 117.87 144.84 117.87 146.74 112.56 138.24 112.56 140.13 117.87",
    fill: "#2c7be5"
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    x: 137.91,
    y: 110.34,
    width: 9.08,
    height: 2.42,
    opacity: 0.58,
    fill: "url(#linear-gradient-59)"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.13 117.87 144.84 117.87 146.74 112.56 138.24 112.56 140.13 117.87",
    opacity: 0.58,
    fill: "url(#linear-gradient-60)"
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 116.59,
    width: 3.9,
    height: 2.57,
    rx: 1.14,
    fill: "#2c7be5"
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 116.59,
    width: 3.9,
    height: 2.57,
    rx: 1.14,
    opacity: 0.58,
    fill: "url(#linear-gradient-61)"
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    x: 135.32,
    y: 82.24,
    width: 14.33,
    height: 3.59,
    rx: 1.4,
    fill: "#2c7be5"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.61 84.74 148.27 84.74 155.62 78.93 129.35 78.93 136.61 84.74",
    fill: "#2c7be5"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.61 84.74 148.27 84.74 155.62 78.93 129.35 78.93 136.61 84.74",
    opacity: 0.58,
    fill: "url(#linear-gradient-62)"
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    x: 129.27,
    y: 76.63,
    width: 26.44,
    height: 2.3,
    fill: "#2c7be5"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.49 69.38 129.27 69.38 130.35 73.02 129.27 76.65 142.49 76.65 155.71 76.65 154.62 73.02 155.71 69.38 142.49 69.38",
    fill: "#2c7be5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.62,93.54c-.3.28,1.65,1.25,1,3.91s-7.87,5.54-7.87,8,2,5.86,2,5.86h9.61c2.12,0,6.24-5.1,3.8-12.38C113.33,93.33,106.91,93.27,106.62,93.54Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.62,93.54c-.3.28,1.65,1.25,1,3.91s-7.87,5.54-7.87,8,2,5.86,2,5.86h9.61c2.12,0,6.24-5.1,3.8-12.38C113.33,93.33,106.91,93.27,106.62,93.54Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient-63)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.93,192.93c-9.19,0-17.15,6.08-17.15,13s3,9.77,3,9.77,29.67.65,29.67.65,2.24-2.75,2.24-9.41S163.86,192.93,152.93,192.93Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153,194.82c-8.91,0-16.62,5.89-16.62,12.62s2.87,9.47,2.87,9.47,28.76.63,28.76.63,2.17-2.66,2.17-9.12S163.63,194.82,153,194.82Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153,194.82c-8.91,0-16.62,5.89-16.62,12.62s2.87,9.47,2.87,9.47,28.76.63,28.76.63,2.17-2.66,2.17-9.12S163.63,194.82,153,194.82Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-64)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.08,242.65c-.07-3,.14-11.94.5-12.66a51.87,51.87,0,0,0,1.09-13.25,110.41,110.41,0,0,0-1.95-10.92s-4.85-3.84-10.35-3.41-11.22,5.29-11.22,5.29.29,16.35,1.81,20-1.81,10.64-1.81,10.64l12.66,14.91,13.75-3.91S164.15,245.62,164.08,242.65Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M203,397.15c-1.31,1.62-4.88,3.42-4.88,5.52,0,1.49.88,20.34,1.18,31.59A350.43,350.43,0,0,1,157.49,429a253.85,253.85,0,0,1-29.87-7.51s0,0,0,0c-2.41.92-4.83,0-6.77-2.28h0c-1.88-.67-3.76-1.37-5.62-2.1.37-4.18,1-8.13,1.59-11.68.18-1,.35-1.94.53-2.86,1-5.26,1.92-9.53,2-12.3.06-2-.29-10-.64-19.71a17.54,17.54,0,0,0-.34-2.83,18.85,18.85,0,0,0-1-3.29c-.12-.31-.24-.62-.37-.92a1.17,1.17,0,0,1,0-.11v0l-.26-.6c-.18-.39-.36-.77-.55-1.16s-.25-.55-.38-.81c-.43-.88-.86-1.77-1.24-2.67a17.71,17.71,0,0,1-1.55-7c-.1-6,3.06-15.05,4.59-20a23.8,23.8,0,0,0,.78-2.93,1.08,1.08,0,0,0,0-.51,1.15,1.15,0,0,0-.06-.17l-.06-.12,0,0a.27.27,0,0,0-.09-.12,1.51,1.51,0,0,0-.43-.34,2.06,2.06,0,0,0-.37-.16,14.78,14.78,0,0,0-1.71-.46c-.4-.08-.81-.17-1.22-.28a8.7,8.7,0,0,1-2.27-.86,1.9,1.9,0,0,1-.39-.23,4.91,4.91,0,0,1-.65-.5,2.27,2.27,0,0,1-.38-.38l-.07-.07h0a6.12,6.12,0,0,1-1.37-3.9c-.66-12.54,10.07-24.35,10.3-29.78.54-12.81-8.16-9.5-9.16-14.51-.92-4.57,2.67-10.22,2.93-17.59a23.72,23.72,0,0,0-2.79-11.39,31.05,31.05,0,0,0-3.18-5.08c-.62-.83-1-1.28-1-1.28l7.12-6.15h0l11.79-10.21,1.07-.94,1.53-1.31.69-.6h0l.63.61c.24.24.55.52.9.87l.39.37c.12.12.24.25.37.37l1.39,1.37.8.78a97.24,97.24,0,0,1,7.35,7.87c.38.51.91,1.25,1.54,2.14.27.38.57.8.89,1.23,3.32,4.6,8.62,11.62,12.23,13.24,3.09,1.38,7,0,10.27-.86.35-.11.69-.19,1-.28a14.47,14.47,0,0,1,1.57-.31,6.16,6.16,0,0,1,2,0,26,26,0,0,1,5.47,1.66l.06,0a.26.26,0,0,0,.09.05,19.2,19.2,0,0,1,8.6,6.94,10.72,10.72,0,0,1,.61,1,9.17,9.17,0,0,1,.46.88c.59,1.22,1.49,5.66,2.58,12.24,1.31,7.82,2.89,18.7,4.55,30.82.12.91.24,1.84.37,2.78.63,4.71,1.27,9.59,1.92,14.53.41,3.2.83,6.43,1.22,9.66.1.69.18,1.39.27,2.08s.17,1.45.27,2.17c.3,2.35.58,4.7.87,7,0,0,0,.06,0,.1.09.66.17,1.34.25,2s.14,1.24.23,1.86c.2,1.71.4,3.43.61,5.11,0,.22.06.45.08.68.09.76.18,1.5.27,2.25.31,2.67.62,5.29.92,7.83.08.76.18,1.51.26,2.25,0,.28.06.57.1.84C202.06,382.48,203.45,396.61,203,397.15Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M203,397.15c-1.31,1.62-4.88,3.42-4.88,5.52,0,1.49.88,20.34,1.18,31.59A350.43,350.43,0,0,1,157.49,429a253.85,253.85,0,0,1-29.87-7.51s0,0,0,0c-2.41.92-4.83,0-6.77-2.28h0c-1.88-.67-3.76-1.37-5.62-2.1.37-4.18,1-8.13,1.59-11.68.18-1,.35-1.94.53-2.86,1-5.26,1.92-9.53,2-12.3.06-2-.29-10-.64-19.71a17.54,17.54,0,0,0-.34-2.83,18.85,18.85,0,0,0-1-3.29c-.12-.31-.24-.62-.37-.92a1.17,1.17,0,0,1,0-.11v0l-.26-.6c-.18-.39-.36-.77-.55-1.16s-.25-.55-.38-.81c-.43-.88-.86-1.77-1.24-2.67a17.71,17.71,0,0,1-1.55-7c-.1-6,3.06-15.05,4.59-20a23.8,23.8,0,0,0,.78-2.93,1.08,1.08,0,0,0,0-.51,1.15,1.15,0,0,0-.06-.17l-.06-.12,0,0a.27.27,0,0,0-.09-.12,1.51,1.51,0,0,0-.43-.34,2.06,2.06,0,0,0-.37-.16,14.78,14.78,0,0,0-1.71-.46c-.4-.08-.81-.17-1.22-.28a8.7,8.7,0,0,1-2.27-.86,1.9,1.9,0,0,1-.39-.23,4.91,4.91,0,0,1-.65-.5,2.27,2.27,0,0,1-.38-.38l-.07-.07h0a6.12,6.12,0,0,1-1.37-3.9c-.66-12.54,10.07-24.35,10.3-29.78.54-12.81-8.16-9.5-9.16-14.51-.92-4.57,2.67-10.22,2.93-17.59a23.72,23.72,0,0,0-2.79-11.39,31.05,31.05,0,0,0-3.18-5.08c-.62-.83-1-1.28-1-1.28l7.12-6.15h0l11.79-10.21,1.07-.94,1.53-1.31.69-.6h0l.63.61c.24.24.55.52.9.87l.39.37c.12.12.24.25.37.37l1.39,1.37.8.78a97.24,97.24,0,0,1,7.35,7.87c.38.51.91,1.25,1.54,2.14.27.38.57.8.89,1.23,3.32,4.6,8.62,11.62,12.23,13.24,3.09,1.38,7,0,10.27-.86.35-.11.69-.19,1-.28a14.47,14.47,0,0,1,1.57-.31,6.16,6.16,0,0,1,2,0,26,26,0,0,1,5.47,1.66l.06,0a.26.26,0,0,0,.09.05,19.2,19.2,0,0,1,8.6,6.94,10.72,10.72,0,0,1,.61,1,9.17,9.17,0,0,1,.46.88c.59,1.22,1.49,5.66,2.58,12.24,1.31,7.82,2.89,18.7,4.55,30.82.12.91.24,1.84.37,2.78.63,4.71,1.27,9.59,1.92,14.53.41,3.2.83,6.43,1.22,9.66.1.69.18,1.39.27,2.08s.17,1.45.27,2.17c.3,2.35.58,4.7.87,7,0,0,0,.06,0,.1.09.66.17,1.34.25,2s.14,1.24.23,1.86c.2,1.71.4,3.43.61,5.11,0,.22.06.45.08.68.09.76.18,1.5.27,2.25.31,2.67.62,5.29.92,7.83.08.76.18,1.51.26,2.25,0,.28.06.57.1.84C202.06,382.48,203.45,396.61,203,397.15Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-65)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.38,205.53c-5.07-5.58-11.51-3.48-12.3-3.48s-6-1.08-10.28,2.61a11.86,11.86,0,0,0-4.05,7s-1.07,1-1.23,3.76c-.29,4.85,5.54,7.82,5.54,7.82l22.48.29s4.62-2.75,4.91-5-1.74-5.06-1.89-5.57S167.91,208.3,165.38,205.53Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.35 259.58 239.18 240.26 223.54 223.96 227.35 259.58",
    fill: "#2c7be5"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.35 259.58 239.18 240.26 223.54 223.96 227.35 259.58",
    opacity: 0.58,
    fill: "url(#linear-gradient-66)"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.39 283.57 230.39 285.85 238.98 287.37 268.71 238.63 265.13 236.46 230.39 283.57",
    fill: "#2c7be5"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.39 283.57 230.39 285.85 238.98 287.37 268.71 238.63 265.13 236.46 230.39 283.57",
    opacity: 0.58,
    fill: "url(#linear-gradient-67)"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.78 255.46 230.39 283.57 236.25 285.2 265.13 236.46 245.91 225.71 227.78 255.46",
    fill: "#2c7be5"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.78 255.46 230.39 283.57 236.25 285.2 265.13 236.46 245.91 225.71 227.78 255.46",
    opacity: 0.58,
    fill: "url(#linear-gradient-68)"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.15 364.02 219.89 352.08 205.33 228.7 198.15 364.02",
    fill: "#2c7be5"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.15 364.02 219.89 352.08 205.33 228.7 198.15 364.02",
    opacity: 0.58,
    fill: "url(#linear-gradient-69)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M203,397.15c-1.31,1.62-4.88,3.42-4.88,5.52,0,1.49.88,20.34,1.18,31.59A350.43,350.43,0,0,1,157.49,429c7.47-3.73,14.12-7.33,14.12-9,0-3.69-9.13-5.64-9.34-8.68v-.06c.09-2,12.47-9.27,21.45-14.27,5.14-2.86,9.16-5,9.16-5L191,363.45l-.63-9.68-.27-4.16L190,347.5l-.33-5.24-.76-11.58L184,257.31a10.72,10.72,0,0,1,.61,1,9.17,9.17,0,0,1,.46.88c.59,1.22,1.49,5.66,2.58,12.24,1.31,7.82,2.89,18.7,4.55,30.82.12.91.24,1.84.37,2.78.63,4.71,1.27,9.59,1.92,14.53.41,3.2.83,6.43,1.22,9.66.1.69.18,1.39.27,2.08s.17,1.45.27,2.17c.3,2.35.58,4.7.87,7,0,0,0,.06,0,.1.09.66.17,1.34.25,2s.14,1.24.23,1.86c.2,1.71.4,3.43.61,5.11,0,.22.06.45.08.68.09.76.18,1.5.27,2.25.31,2.67.62,5.29.92,7.83.08.76.18,1.51.26,2.25,0,.28.06.57.1.84C202.06,382.48,203.45,396.61,203,397.15Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M203,397.15c-1.31,1.62-4.88,3.42-4.88,5.52,0,1.49.88,20.34,1.18,31.59A350.43,350.43,0,0,1,157.49,429c7.47-3.73,14.12-7.33,14.12-9,0-3.69-9.13-5.64-9.34-8.68v-.06c.09-2,12.47-9.27,21.45-14.27,5.14-2.86,9.16-5,9.16-5L191,363.45l-.63-9.68-.27-4.16L190,347.5l-.33-5.24-.76-11.58L184,257.31a10.72,10.72,0,0,1,.61,1,9.17,9.17,0,0,1,.46.88c.59,1.22,1.49,5.66,2.58,12.24,1.31,7.82,2.89,18.7,4.55,30.82.12.91.24,1.84.37,2.78.63,4.71,1.27,9.59,1.92,14.53.41,3.2.83,6.43,1.22,9.66.1.69.18,1.39.27,2.08s.17,1.45.27,2.17c.3,2.35.58,4.7.87,7,0,0,0,.06,0,.1.09.66.17,1.34.25,2s.14,1.24.23,1.86c.2,1.71.4,3.43.61,5.11,0,.22.06.45.08.68.09.76.18,1.5.27,2.25.31,2.67.62,5.29.92,7.83.08.76.18,1.51.26,2.25,0,.28.06.57.1.84C202.06,382.48,203.45,396.61,203,397.15Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-70)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M166.78,319.88V320c-.08,1.68-.18,3.44-.26,5.25-.68,12.86-1.63,28.26-2.53,38.23-.54,6.25-1.08,10.37-1.51,10.4-1.8.17-9-4.88-11.4.83s-14.82,39.73-21.17,45.42a7.06,7.06,0,0,1-2.29,1.43s0,0,0,0c-2.41.92-4.83,0-6.77-2.28h0c-2.34-2.78-4-7.6-4-13.78,0-.9,0-1.83.09-2.8,0,0,.15,0,.44-.06,1.84-.26,9.15-1.71,13.39-8.07,4.88-7.33,13-18.89,16.45-21.82,1.32-1.14,4.11-5,7.07-9.27l.58-.84,3.59-5.29c.33-.5.66-1,1-1.46,0,0,.07-.1.11-.15,1.38-2,3.47-16.95,5.15-30.49l.65-5.34.07-.64c1.14-9.39,2-16.89,2-16.89S167.28,309.83,166.78,319.88Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M112.75,230.74c-3,2.75-11.31,9.85-10,13.18,3.61,9.46,20.31-1.29,24.58-19.87,2.23-9.67,2.17-9.13-3-17.59C124.26,206.46,115.77,228,112.75,230.74Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.75,230.74c-3,2.75-11.31,9.85-10,13.18,3.61,9.46,20.31-1.29,24.58-19.87,2.23-9.67,2.17-9.13-3-17.59C124.26,206.46,115.77,228,112.75,230.74Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-71)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101.36,132.14a3.58,3.58,0,0,0-1.08,3.09c.33,1.17-.72,5.35-.76,5.63-.07.44.22,3.69.22,3.69s2.49.62,2.13,1.56-2.21,1.91-2.39,2.28,2.79,6.65,2.79,6.65.14-1.48.22-2.71,2.6-3.11,4.63-2.39,3.95,5.39,3.95,5.39l.79-22.25L102,133S101.85,131.81,101.36,132.14Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M101.36,132.14a3.58,3.58,0,0,0-1.08,3.09c.33,1.17-.72,5.35-.76,5.63-.07.44.22,3.69.22,3.69s2.49.62,2.13,1.56-2.21,1.91-2.39,2.28,2.79,6.65,2.79,6.65.14-1.48.22-2.71,2.6-3.11,4.63-2.39,3.95,5.39,3.95,5.39l.79-22.25L102,133S101.85,131.81,101.36,132.14Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-72)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M164.14,243.24c-.52-1.45.44-13.25.44-13.25l5.2-10s.59-.21.69-2.16-1.83-4.27-1.91-4.85a6.25,6.25,0,0,0-.57-2.2c-.51-1.19-13.54-5.18-14.12-5.11s-8.1,3-10.56,4.78-5.05,5-5,8.38,4.41,10.29,4.41,10.29l.64-3.7s-.56-4.48-.15-6.14,2.68-2,5.07-1.88,3.26-.8,3.18-2.68-5.71-.36-6.36-.87,8.46-6.95,8.87-6.95a69.92,69.92,0,0,1,8,5.71c.22.42-5.28-.28-6.44.59s-.58,7-.36,7.81-1.31,1.09-2.39,1-2.16,1.21-1.52,1.08c1.08-.22,2.39,1.23,1.59,1.38a10.18,10.18,0,0,0-2.46,1.26s2.92-.69,4-.33c.39.13-.13,1.6.16,2s3.47-.65,3.47-1.88-1.16-4.05-1.16-5.72,4.49-1.95,5.79.12-5.57,10.74-8,11.1-8.35-1.16-9.3-1.08-.43,1.44,6.95,10.27a25.25,25.25,0,0,0,14.2,8.84c1.26.26,8.88,1.33,8.88,1.33S164.67,244.68,164.14,243.24Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M164.14,243.24c-.52-1.45.44-13.25.44-13.25l5.2-10s.59-.21.69-2.16-1.83-4.27-1.91-4.85a6.25,6.25,0,0,0-.57-2.2c-.51-1.19-13.54-5.18-14.12-5.11s-8.1,3-10.56,4.78-5.05,5-5,8.38,4.41,10.29,4.41,10.29l.64-3.7s-.56-4.48-.15-6.14,2.68-2,5.07-1.88,3.26-.8,3.18-2.68-5.71-.36-6.36-.87,8.46-6.95,8.87-6.95a69.92,69.92,0,0,1,8,5.71c.22.42-5.28-.28-6.44.59s-.58,7-.36,7.81-1.31,1.09-2.39,1-2.16,1.21-1.52,1.08c1.08-.22,2.39,1.23,1.59,1.38a10.18,10.18,0,0,0-2.46,1.26s2.92-.69,4-.33c.39.13-.13,1.6.16,2s3.47-.65,3.47-1.88-1.16-4.05-1.16-5.72,4.49-1.95,5.79.12-5.57,10.74-8,11.1-8.35-1.16-9.3-1.08-.43,1.44,6.95,10.27a25.25,25.25,0,0,0,14.2,8.84c1.26.26,8.88,1.33,8.88,1.33S164.67,244.68,164.14,243.24Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-73)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2,139.38a14.6,14.6,0,0,0-3.48-3.91c-.5-.29-2-.22-2.17,2.1s3.55,6.8,3.19,9.33,1.74,8.88,1.68,6.95c-.25-8.55,3-9.32,2.82-10.12A35.27,35.27,0,0,0,113.2,139.38Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M219.77,293c-.94,1.32.81,3.92.45,4.25s-3.16-.75-3.58.45,1.74,3.67,1.41,3.75-3.36-2.19-4.19-.42c-.36.78.79,2.26.61,2.41s-2.44-.36-1.87,2.24a26.32,26.32,0,0,0,1.9,4l9.41-15.63S220.25,292.31,219.77,293Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-74)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M212.75,304.06c-.53.71,1.16,2.94,1.77,3.91s1.81,2.93,2.43,2.93,2-1,2-1.3a32.89,32.89,0,0,0-2.31-3.58C216,305.15,213.58,302.94,212.75,304.06Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M218.46,301.91c-.8-.75-3.82-2.41-4.4-1.06-.37.85,1.9,2.71,2.77,3.56s2.57,2.56,3.2,2.41,1.76-1.48,1.68-1.81A31.9,31.9,0,0,0,218.46,301.91Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M221.2,298.7c-.82-.76-3.91-2.46-4.5-1.08-.37.87,2,2.77,2.83,3.64s2.62,2.61,3.26,2.45,1.8-1.51,1.72-1.85A33.11,33.11,0,0,0,221.2,298.7Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M219.72,293.18c-.49.81,1.53,3,2.28,4s2.23,3,2.89,2.89,2-1.23,2-1.58a34.8,34.8,0,0,0-2.83-3.6C223.31,294,220.5,291.9,219.72,293.18Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M212.75,304.06c-.53.71,1.16,2.94,1.77,3.91s1.81,2.93,2.43,2.93,2-1,2-1.3a32.89,32.89,0,0,0-2.31-3.58C216,305.15,213.58,302.94,212.75,304.06Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient-75)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M218.46,301.91c-.8-.75-3.82-2.41-4.4-1.06-.37.85,1.9,2.71,2.77,3.56s2.57,2.56,3.2,2.41,1.76-1.48,1.68-1.81A31.9,31.9,0,0,0,218.46,301.91Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient-76)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M221.2,298.7c-.82-.76-3.91-2.46-4.5-1.08-.37.87,2,2.77,2.83,3.64s2.62,2.61,3.26,2.45,1.8-1.51,1.72-1.85A33.11,33.11,0,0,0,221.2,298.7Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient-77)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M219.72,293.18c-.49.81,1.53,3,2.28,4s2.23,3,2.89,2.89,2-1.23,2-1.58a34.8,34.8,0,0,0-2.83-3.6C223.31,294,220.5,291.9,219.72,293.18Z",
    transform: "translate(35.88 -47.34)",
    fill: "url(#linear-gradient-78)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M100.06,136.48a2.67,2.67,0,0,0-1.81,2.71,2.28,2.28,0,0,0,1.29,1.58c.43,0,.78-1.43,4.9-1.18a1.77,1.77,0,0,0,2.1-2C106.43,136.48,101.26,136.15,100.06,136.48Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M105.16,141.4c-1.15-.32-5.37-1-5.86-.54-1.55,1.3-.07,3.47.44,3.69a67.82,67.82,0,0,0,8.57.11c.62-.15.73-1.52.29-2.06S106.32,141.73,105.16,141.4Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M104.22,145.35c-1-.2-4.19-.93-4.56-.55-1.17,1.23-.61,3.44-.18,3.59a53.92,53.92,0,0,0,7.14-.38c.49-.16.48-1.35.09-1.79A6.92,6.92,0,0,0,104.22,145.35Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M142.54,285.37c-12.37,9.12-30.71,27.59-32.17,32.15a12.87,12.87,0,0,0,.23,6.51c2.44,2.84,7.29,1.91,7.73,3.72,0-1.3.46-5.36,3.76-15.28,2.15-6.44,15.48-17,24-25.52,8.3-8.27,11.83-14.54,11.83-14.54S154.92,276.25,142.54,285.37Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M114.52,358.19c1.34,3.18,3.17,5.94,3.88,9.8l.27-.05,39.25-89.18s-9,15.74-16.71,27.51C128.4,325.92,114.52,358.19,114.52,358.19Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101.64,128.39c-.55-.11-2.93,3.64-3.15,5.11s1.14,3.36,1.14,3.36l1.88-.43s-.05-1.09-.08-1.69.91-2.22,1.13-3.25S102.18,128.5,101.64,128.39Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M128,213.06l-.19-.44h0s-3.82,17.92-5.91,22.52c-3.28,7.2-9.37,9.6-8.8,10.64,1,1.83,3.48,5.32,3.8,10.75s-2.22,9.4-.59,9.72,8.66-9.6,11.5-21.16c2.16-8.84,3.72-16.91,4.33-20.23-2.06-2-3.68-3.59-3.68-3.59S129.51,215.4,128,213.06Z",
    transform: "translate(35.88 -47.34)",
    fill: "#2c7be5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M128,213.06l-.19-.44h0s-3.82,17.92-5.91,22.52c-3.28,7.2-9.37,9.6-8.8,10.64,1,1.83,3.48,5.32,3.8,10.75s-2.22,9.4-.59,9.72,8.66-9.6,11.5-21.16c2.16-8.84,3.72-16.91,4.33-20.23-2.06-2-3.68-3.59-3.68-3.59S129.51,215.4,128,213.06Z",
    transform: "translate(35.88 -47.34)",
    opacity: 0.58,
    fill: "url(#linear-gradient-79)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewYork);
export default __webpack_public_path__ + "static/media/new-york.c318658c6269b9c702d4895c1d98c7e7.svg";
export { ForwardRef as ReactComponent };